import { Game, Category } from '../types';
import { FeaturedGame } from '../types/game';
// mysql -uroot -D poki_clone -e "SELECT JSON_ARRAYAGG(
//   JSON_OBJECT(
//     'id', id,
//     'title', title,
//     'thumbnailUrl', thumbnail_url,
//     'description', IFNULL(description, ''),
//     'category_id', category_id,
//     'gameUrl', game_url,
//     'urlkey', urlkey,
//     'layout', layout,
//     'rating', rating,
//     'ratingCount', ratingCount
//   )
// ) AS items
// FROM games" > temp.txt
export const allGames: FeaturedGame[] = [
    {
        "id": 18,
        "title": "1010 Color Match",
        "layout": "auto",
        "rating": 4.1,
        "urlkey": "1010-Color-Match",
        "gameUrl": "https://pagegame.randplays.com/1010ColorMatch/",
        "category_id": 2,
        "description": "​​1010 Color Match​​ is a puzzle strategy game where you match 3+ same-colored blocks to clear them. Place different-shaped pieces strategically to create combos and earn bonus points!\n\nWith increasing difficulty, vibrant visuals, and engaging sound effects, it’s a perfect brain-teasing break anytime, anywhere. Test your skills and see how far you can go!",
        "ratingCount": 1091,
        "thumbnailUrl": "https://images.randplays.com/1010ColorMatch.png"
    },
    {
        "id": 23,
        "title": "Blumgi Slime",
        "layout": "landscape",
        "rating": 4.8,
        "urlkey": "Blumgi-Slime",
        "gameUrl": "https://pagegame.randplays.com/BlumgiSlime/",
        "category_id": 9,
        "description": "Blumgi Slime is an arcade game that will put your timing and aiming skills to the test by jumping to the finish line.",
        "ratingCount": 2795,
        "thumbnailUrl": "https://images.randplays.com/BlumgiSlime.png"
    },
    {
        "id": 25,
        "title": "Brain Test Tricky Puzzles",
        "layout": "auto",
        "rating": 4.7,
        "urlkey": "Brain-Test-Tricky-Puzzles",
        "gameUrl": "https://pagegame.randplays.com/BrainTestTrickyPuzzles",
        "category_id": 1,
        "description": "Brain Test: Tricky Puzzles is a puzzle game featuring many tricky riddles and puzzles. There are over 275 brain-teasing levels designed to trick the player.",
        "ratingCount": 2617,
        "thumbnailUrl": "https://images.randplays.com/BrainTestTrickyPuzzles.png"
    },
    {
        "id": 29,
        "title": "Bubble Woods",
        "layout": "auto",
        "rating": 4.4,
        "urlkey": "Bubble-Woods",
        "gameUrl": "https://pagegame.randplays.com/BubbleWoods",
        "category_id": 2,
        "description": "Bubble woods is a beautiful themed bubble shooter. Help the beaver to clear the playing field as fast as you can. The twist in bubble woods is that you have 60 seconds to set the top score. So this is a fast pacing game! You can shoot the balls via the wall to get in to tricky spots. Be sure to make big combinations instead of shooting 3 bubbles. If you remove big clusters you get more points!",
        "ratingCount": 2386,
        "thumbnailUrl": "https://images.randplays.com/BubbleWoods.png"
    },
    {
        "id": 37,
        "title": "Chickens Merge",
        "layout": "landscape",
        "rating": 4.3,
        "urlkey": "Chickens-Merge",
        "gameUrl": "https://pagegame.randplays.com/ChickensMerge/",
        "category_id": 7,
        "description": "Chicken Merge is a merge game with tower defense elements in which your objective is to deploy numerous chickens to protect your base from hordes of enemies.",
        "ratingCount": 5515,
        "thumbnailUrl": "https://images.randplays.com/ChickensMerge.png"
    },
    {
        "id": 43,
        "title": "Duo Survival",
        "layout": "landscape",
        "rating": 5,
        "urlkey": "Duo-Survival",
        "gameUrl": "https://pagegame.randplays.com/DuoSurvival",
        "category_id": 4,
        "description": "Duo Survival is a 2-player cooperative game by 7Spot Games where you help two apocalypse survivors escape from the zombies through obstacle-filled levels.",
        "ratingCount": 7664,
        "thumbnailUrl": "https://images.randplays.com/DuoSurvival.png"
    },
    {
        "id": 54,
        "title": "Gobble",
        "layout": "auto",
        "rating": 4.1,
        "urlkey": "Gobble",
        "gameUrl": "https://pagegame.randplays.com/Gobble",
        "category_id": 12,
        "description": "Gobble is an arcade game where you play as a mouth in the ground and your aim is to eat everything except people! Move around the ground and gobble up",
        "ratingCount": 4008,
        "thumbnailUrl": "https://images.randplays.com/Gobble.png"
    },
    {
        "id": 62,
        "title": "Its Story Time",
        "layout": "auto",
        "rating": 4.6,
        "urlkey": "Its-Story-Time",
        "gameUrl": "https://pagegame.randplays.com/ItsStoryTime",
        "category_id": 9,
        "description": "Find hidden objects, drag and drop multiple objects to mix them, remove parts of objects, open closets and drawers, and much more.",
        "ratingCount": 4647,
        "thumbnailUrl": "https://images.randplays.com/ItsStoryTime.png"
    },
    {
        "id": 67,
        "title": "Match Good 3D",
        "layout": "auto",
        "rating": 4.7,
        "urlkey": "Match-Good-3D",
        "gameUrl": "https://pagegame.randplays.com/MatchGood3D",
        "category_id": 9,
        "description": "Tap to select and match three identical items to clear them. Sort through stacks of 3D objects to find matches. Use boosters to help solve difficult puzzles.",
        "ratingCount": 6658,
        "thumbnailUrl": "https://images.randplays.com/MatchGood3D.png"
    },
    {
        "id": 72,
        "title": "Moto X3M Spooky Land",
        "layout": "landscape",
        "rating": 4.6,
        "urlkey": "Moto-X3M-Spooky-Land",
        "gameUrl": "https://pagegame.randplays.com/MotoX3MSpookyLand",
        "category_id": 1,
        "description": "Moto X3M Spooky Land is a stunt motor bike game and is the sixth release in the Moto X3M series. This time with a complete halloween theme",
        "ratingCount": 8760,
        "thumbnailUrl": "https://images.randplays.com/MotoX3MSpookyLand.png"
    },
    {
        "id": 77,
        "title": "OMG Word Swipe",
        "layout": "auto",
        "rating": 4,
        "urlkey": "OMG-Word-Swipe",
        "gameUrl": "https://pagegame.randplays.com/OMGWordSwipe/",
        "category_id": 7,
        "description": "Playing Omg Word Swipe is that simple! Play this Words game online. 17293 total plays, play now!",
        "ratingCount": 9413,
        "thumbnailUrl": "https://images.randplays.com/OMGWordSwipe.png"
    },
    {
        "id": 101,
        "title": "Subway Surfers",
        "layout": "auto",
        "rating": 4.4,
        "urlkey": "Subway-Surfers",
        "gameUrl": "https://pagegame.randplays.com/SubwaySurfers",
        "category_id": 12,
        "description": "Subway Surfers is a classic endless runner game. You play as Jake, who surfs the subways and tries to escape from the grumpy Inspector and his dog.\n",
        "ratingCount": 7457,
        "thumbnailUrl": "https://images.randplays.com/SubwaySurfers.png"
    },
    {
        "id": 109,
        "title": "Block Blast",
        "layout": "auto",
        "rating": 4.6,
        "urlkey": "Block-Blast",
        "gameUrl": "https://block-blast.io/block-blast.embed",
        "category_id": 1,
        "description": "Block Blast Game is a captivating puzzle game that challenges you to fit different block shapes onto a grid, clearing lines to score points. The game’s simplicity is its charm, but don’t be fooled—mastering Block Blast takes skill, strategy, and a sharp mind.",
        "ratingCount": 1876,
        "thumbnailUrl": "https://images.randplays.com/block-blast-puzzle.png"
    },
    {
        "id": 111,
        "title": "Escape Road Winter",
        "layout": "landscape",
        "rating": 4.5,
        "urlkey": "Escape-Road-Winter",
        "gameUrl": "https://azgames.io/escape-road-winter.embed",
        "category_id": 1,
        "description": "Escape Road Winter - Immerse yourself in the cold winter air, explore the snow-covered landscapes. Solve challenges to find a way out of the city covered in ice and snow.",
        "ratingCount": 9794,
        "thumbnailUrl": "https://images.randplays.com/escaperoadwinter.png"
    },
    {
        "id": 112,
        "title": "Chill Guy Clicker",
        "layout": "landscape",
        "rating": 3.8,
        "urlkey": "Chill-Guy-Clicker",
        "gameUrl": "https://game.azgame.io/chill-guy-clicker/",
        "category_id": 1,
        "description": "Play Chill Guy Clicker game because you are just a Chill Guy!",
        "ratingCount": 7690,
        "thumbnailUrl": "https://images.randplays.com/chillguyclicker3.png"
    },
    {
        "id": 113,
        "title": "Astro Robot Clicker",
        "layout": "landscape",
        "rating": 4,
        "urlkey": "Astro-Robot-Clicker",
        "gameUrl": "https://game.azgame.io/astro-robot-clicker/",
        "category_id": 4,
        "description": "Astro Robot Clicker is the best clicker game, transporting you to a thrilling space journey! Get ready to discover the universe's mysteries and establish a timeless empire of technology.",
        "ratingCount": 8066,
        "thumbnailUrl": "https://images.randplays.com/astrorobotclicker.png"
    },
    {
        "id": 114,
        "title": "Supermarket Master",
        "layout": "landscape",
        "rating": 4.9,
        "urlkey": "Supermarket-Master",
        "gameUrl": "https://game.azgame.io/supermarket-master/",
        "category_id": 4,
        "description": "Build your retail empire with Supermarket Master! Manage stores, expand departments, and attract customers in this fun, addictive business simulator. Start growing now!",
        "ratingCount": 7261,
        "thumbnailUrl": "https://images.randplays.com/supermarket_master_s2.png"
    },
    {
        "id": 115,
        "title": "Sprunki Clicker",
        "layout": "landscape",
        "rating": 3.9,
        "urlkey": "Sprunki-Clicker",
        "gameUrl": "https://game.azgame.io/sprunki-clicker",
        "category_id": 9,
        "description": "Spunki Clicker is an endless idle clicker game featuring the main character named Sprunki, who looks quite quirky. In the game, players’ main goal is to click/tap, collect points, and unlock upgrades. The more you click or tap, the more points you will earn, which then can be used to unlock lots of handy upgrades for idle points earning. That’s it!",
        "ratingCount": 2106,
        "thumbnailUrl": "https://images.randplays.com/sprunkiclicker.png"
    },
    {
        "id": 116,
        "title": "Titans Clicker",
        "layout": "landscape",
        "rating": 4.4,
        "urlkey": "Titans-Clicker",
        "gameUrl": "https://game.azgame.io/titans-clicker/",
        "category_id": 1,
        "description": "Titans Clicker is an extremely attractive action clicker game. Where you will have to play the role of a brave hero, fighting against giant Titans to protect the world. Titans Clicker with its simple but addictive clicking gameplay, has attracted millions of players worldwide.",
        "ratingCount": 5750,
        "thumbnailUrl": "https://images.randplays.com/titansclicker.png"
    },
    {
        "id": 117,
        "title": "Cookie Clicker",
        "layout": "landscape",
        "rating": 4.3,
        "urlkey": "Cookie-Clicker",
        "gameUrl": "https://azgames.io/cookie-clicker.embed",
        "category_id": 1,
        "description": "Cookie Clicker is a trending clicker game in which players begin by clicking on a cookie to make more cookies. The objective of the game is to collect the most cookies possible.",
        "ratingCount": 3429,
        "thumbnailUrl": "https://images.randplays.com/cookieclickerthumb.png"
    },
    {
        "id": 118,
        "title": "Monkey mart",
        "layout": "auto",
        "rating": 4.4,
        "urlkey": "Monkey-mart",
        "gameUrl": "https://azgames.io/monkey-mart.embed",
        "category_id": 9,
        "description": "If you like the job of managing and coordinating stalls, you can’t try to play the Monkey Mart game. In this game, you will open a supermarket selling food in this game. You will serve gourmet monkeys in a whole new world. Let’s build and grow your supermarket right now!",
        "ratingCount": 7899,
        "thumbnailUrl": "https://images.randplays.com/monkeymart.png"
    },
    {
        "id": 119,
        "title": "Escape Jump",
        "layout": "landscape",
        "rating": 4.3,
        "urlkey": "Escape-Jump",
        "gameUrl": "https://game.azgame.io/escape-jump/",
        "category_id": 4,
        "description": "Play Escape Road as a bank robber dodging traffic and obstacles in this addictive pixel art game.",
        "ratingCount": 1206,
        "thumbnailUrl": "https://images.randplays.com/escapejump1.png"
    },
    {
        "id": 120,
        "title": "Chill Girl Clicker",
        "layout": "landscape",
        "rating": 4.4,
        "urlkey": "Chill-Girl-Clicker",
        "gameUrl": "https://game.azgame.io/chill-girl-clicker/",
        "category_id": 9,
        "description": "Chill Girl Clicker is an engaging clicker game inspired by the famous Chill Guy meme. Following the success of Chill Guy Clicker, this version promises to bring you endless entertainment with the combination of the main character being Chill Guy's lovely girlfriend and addictive idle gameplay. Start and enjoy the relaxation of becoming a true Chill Girl.",
        "ratingCount": 8335,
        "thumbnailUrl": "https://images.randplays.com/chillgirlclicker.png"
    },
    {
        "id": 121,
        "title": "Chill Guy Clicker 3D",
        "layout": "auto",
        "rating": 4,
        "urlkey": "Chill-Guy-Clicker-3D",
        "gameUrl": "https://game.azgame.io/chill-guy-clicker-3d/",
        "category_id": 9,
        "description": "Game Chill Guy Clicker 3D lets you click the chill guy for a fun and easy way to relax. Enjoy this game and chill out as you play!",
        "ratingCount": 1055,
        "thumbnailUrl": "https://images.randplays.com/chillguyclicker3d.png"
    },
    {
        "id": 122,
        "title": "Unchill Guy Clicker",
        "layout": "auto",
        "rating": 4.4,
        "urlkey": "Unchill-Guy-Clicker",
        "gameUrl": "https://game.azgame.io/unchill-guy-clicker/",
        "category_id": 1,
        "description": "Unchill Guy Clicker is a fun, addictive clicker game where you control Chill Guy, a grumpy character who wants nothing to do with the fun.",
        "ratingCount": 6271,
        "thumbnailUrl": "https://images.randplays.com/unchillguy3.png"
    },
    {
        "id": 123,
        "title": "Idle Gold Miner",
        "layout": "auto",
        "rating": 3.9,
        "urlkey": "Idle-Gold-Miner",
        "gameUrl": "https://game.azgame.io/idle-gold-miner/",
        "category_id": 4,
        "description": "Dreaming of building your own mining empire, raking in massive profits, and rising to the top as an industrial tycoon? Dive into Idle Gold Miner, where hard work and wise investments turn you into an industrial tycoon.",
        "ratingCount": 9188,
        "thumbnailUrl": "https://images.randplays.com/idlegoldminer.png"
    },
    {
        "id": 124,
        "title": "Duck Clicker",
        "layout": "landscape",
        "rating": 4.8,
        "urlkey": "Duck-Clicker",
        "gameUrl": "https://game.azgame.io/duck-clicker/",
        "category_id": 9,
        "description": "Duck Clicker is a fun, charming idle clicker game where you can grow a duck empire by continuously clicking, earning points or money, and strategically investing in Duck Power upgrades to boost production. As the game progresses, you can unlock and equip cute and unique skins for your duck. Ready to jump in and build your duck empire? Enjoy the game on here today!",
        "ratingCount": 8126,
        "thumbnailUrl": "https://images.randplays.com/duckclicker1.png"
    },
    {
        "id": 125,
        "title": "Chill Clicker",
        "layout": "landscape",
        "rating": 4.7,
        "urlkey": "Chill-Clicker",
        "gameUrl": "https://game.azgame.io/chill-clicker/",
        "category_id": 1,
        "description": "Chill Clicker is a relaxing game featuring the adorable Capybara as the main character. Unlike fast-paced games, it offers a calming experience where you can click and watch as the character progresses through various tasks. Perfect for unwinding and enjoying a stress-free gameplay session!",
        "ratingCount": 3066,
        "thumbnailUrl": "https://images.randplays.com/chillclicker1.png"
    },
    {
        "id": 126,
        "title": "Chicken Jockey Clicker",
        "layout": "landscape",
        "rating": 4.1,
        "urlkey": "Chicken-Jockey-Clicker",
        "gameUrl": "https://game.azgame.io/chicken-jockey-clicker/",
        "category_id": 9,
        "description": "Click or tap repeatedly to earn points and invest wisely in upgrades to reach your best points and unlock all in-game skins. Play Chicken Jockey Clicker free online on here today and enjoy its thrilling gameplay.",
        "ratingCount": 7955,
        "thumbnailUrl": "https://images.randplays.com/chickenjockeyclicker.png"
    },
    {
        "id": 127,
        "title": "Italian Brainrot Clicker 2",
        "layout": "landscape",
        "rating": 4,
        "urlkey": "Italian-Brainrot-Clicker-2",
        "gameUrl": "https://game.azgame.io/italian-brainrot-clicker-2/",
        "category_id": 9,
        "description": "Inspired by the viral TikTok \"Italian Brainrot\" meme trend, Italian Brainrot Clicker 2 offers a hilarious clicker game experience where you’ll encounter Tralalero Tralala, Tung Tung Tung Sahur, Bombardino Crocodilo, and many other bizarre-looking characters. Jump in, click or tap fast, and combine speed with a smart upgrade strategy to unlock every absurd Italian Brainrot monster.",
        "ratingCount": 2575,
        "thumbnailUrl": "https://images.randplays.com/italianbrainrotclicker3.png"
    },
    {
        "id": 128,
        "title": "Tung Sahur Clicker",
        "layout": "landscape",
        "rating": 4.9,
        "urlkey": "Tung-Sahur-Clicker",
        "gameUrl": "https://game.azgame.io/tung-sahur-clicker/",
        "category_id": 4,
        "description": "Tung Sahur Clicker is a fun, fast-paced Ramadan-themed game where you wake up the village before dawn! Tap fast, earn rewards, and become the Galatic Sahur!",
        "ratingCount": 6014,
        "thumbnailUrl": "https://images.randplays.com/tungsahurclicker2.png"
    },
    {
        "id": 129,
        "title": "Ragdoll Hit Stickman",
        "layout": "landscape",
        "rating": 3.9,
        "urlkey": "Ragdoll-Hit-Stickman",
        "gameUrl": "https://game.azgame.io/ragdoll-hit-stickman/",
        "category_id": 4,
        "description": "Ragdoll Hit Stickman is an action-packed fighting game with a variety of characters and weapons, promising intense battles. Play now to experience it!",
        "ratingCount": 3342,
        "thumbnailUrl": "https://images.randplays.com/ragdollhitstickman1.png"
    },
    {
        "id": 130,
        "title": "Curve Rush",
        "layout": "landscape",
        "rating": 4.8,
        "urlkey": "Curve-Rush",
        "gameUrl": "https://game.azgame.io/curve-rush/",
        "category_id": 4,
        "description": "Curve Rush challenges you to fly above the line and score points, but beware! The higher you get, the harder the landing will be. Keep it smooth and avoid crashing! Welcome to Curve Rush, a thrilling running game, where you control a ball sliding over endless sand dunes, making extraordinary jumps, and earning your highest points. However, be aware, it’s not that easy! The game can end at any time if you lose focus. Just a crash, and you’ll have to start over.",
        "ratingCount": 6669,
        "thumbnailUrl": "https://images.randplays.com/curverush2.png"
    },
    {
        "id": 131,
        "title": "1v1.lol",
        "layout": "landscape",
        "rating": 4.6,
        "urlkey": "1v1.lol",
        "gameUrl": "https://azgames.io/1v1lol.embed",
        "category_id": 10,
        "description": "1v1 LOL is a multiplayer battle game that brings an experience that combines competitive gameplay with diverse modes and player customization. The game is for those seeking a skill-based battle game where you go into an arena to face off against a single opponent.",
        "ratingCount": 4319,
        "thumbnailUrl": "https://images.randplays.com/1v1lol.png"
    },
    {
        "id": 132,
        "title": "Krunker",
        "layout": "landscape",
        "rating": 3.9,
        "urlkey": "Krunker",
        "gameUrl": "https://azgames.io/krunker.embed",
        "category_id": 10,
        "description": "Krunker is a first-person shooter action game developed by Yendis Entertainment. Launched in 2018, the game quickly attracted players thanks to its fast-paced gameplay and attractive pixel graphics. In Krunker.io, players will participate in matches with many players from all over the world. The game has many game modes, such as Free for All, Capture the Flag, and Parkour; you can customize your favorite mode. Players can choose from 11 different character skins; each skin has different weapons and fighting styles. The game requires reflexes and aiming skills.",
        "ratingCount": 9587,
        "thumbnailUrl": "https://images.randplays.com/krunker-io.png"
    },
    {
        "id": 133,
        "title": "Paper IO",
        "layout": "auto",
        "rating": 4.2,
        "urlkey": "Paper-IO",
        "gameUrl": "https://azgames.io/paper-io.embed",
        "category_id": 9,
        "description": "Paper IO is a free to play online multiplayer IO game. In the game, you control a cube and are tasked with expanding your territory by capturing an area on the map. When you have to compete to become the player who occupies the most land, Paper IO becomes attractive and interesting. The goal of the game is to occupy as much land as possible. You start with a small area and have to move around the map to draw and expand your territory. When you complete a circle, the part inside the circle will be your territory. Be careful; your opponents can knock you out of the game by moving across your path. You can do the same to them.",
        "ratingCount": 6976,
        "thumbnailUrl": "https://images.randplays.com/paper-io.jpeg"
    },
    {
        "id": 134,
        "title": "Stickman Racing",
        "layout": "auto",
        "rating": 4.4,
        "urlkey": "Stickman-Racing",
        "gameUrl": "https://game.azgame.io/stickman-racing/",
        "category_id": 4,
        "description": "Stickman Racing is a free multiplayer parkour game. where you jump, climb, slide, flip, swing, and run through obstacles. Avoid falling and reach the finish line!",
        "ratingCount": 5121,
        "thumbnailUrl": "https://images.randplays.com/stickmanracing2.png"
    },
    {
        "id": 135,
        "title": "Smash Karts",
        "layout": "landscape",
        "rating": 4.2,
        "urlkey": "Smash-Karts",
        "gameUrl": "https://azgames.io/smash-karts.embed",
        "category_id": 9,
        "description": "Smash Karts is an exciting 3D multiplayer IO kart fighting game. Your mission is to control your go-kart, collect weapons and destroy other karts to win. You will participate in collecting to upgrade and unlock characters and many other interesting rewards!",
        "ratingCount": 3677,
        "thumbnailUrl": "https://images.randplays.com/smash-karts.jpg"
    },
    {
        "id": 136,
        "title": "Paper Minecraft",
        "layout": "landscape",
        "rating": 4.3,
        "urlkey": "Paper-Minecraft",
        "gameUrl": "https://azgames.io/paper-minecraft.embed",
        "category_id": 4,
        "description": "Paper Minecraft is a 2D version of the worldwide famous sandbox game Minecraft. It retains many of the core gameplay mechanics of the legendary game, such as mining, crafting, and building, but brings them into a 2D environment instead of a 3D world. With both Survival and Creative modes available, Paper Minecraft offers a kind of unique yet fulfilling Minecraft experience. Jump into blocky terrains, mine materials, gather resources, and craft tools now!",
        "ratingCount": 2021,
        "thumbnailUrl": "https://images.randplays.com/paperminecraft.png"
    },
    {
        "id": 137,
        "title": "Narrow One",
        "layout": "landscape",
        "rating": 4.8,
        "urlkey": "Narrow-One",
        "gameUrl": "https://azgames.io/narrow-one.embed",
        "category_id": 9,
        "description": "Narrow One is a 3D fast-paced multiplayer first-person archery game where you and your teammates use bows and arrows to capture the enemy's flag while defending yours. Precision, strategy, and effective teamwork are all essential to outplay opponents.",
        "ratingCount": 7074,
        "thumbnailUrl": "https://images.randplays.com/narrow-one.png"
    },
    {
        "id": 138,
        "title": "Shell Shockers",
        "layout": "landscape",
        "rating": 4,
        "urlkey": "Shell-Shockers",
        "gameUrl": "https://azgames.io/shell-shockers.embed",
        "category_id": 9,
        "description": "Shell Shockers lets users play as a fruit-shaped figure with firearms and bombs. The objective is to shoot opponents before the player to score points. The fast-paced game has Free For All, Capture the Spatula, and Team Deathmatch stages and modes.",
        "ratingCount": 1308,
        "thumbnailUrl": "https://images.randplays.com/shell-shockers.jpg"
    },
    {
        "id": 139,
        "title": "Venge IO",
        "layout": "landscape",
        "rating": 3.9,
        "urlkey": "Venge-IO",
        "gameUrl": "https://azgames.io/venge-io.embed",
        "category_id": 10,
        "description": "Welcome to the world of Venge IO, where you can become a professional shooter. This is a multiplayer online game created by Cem Demir and released in 2020. Guns are not allowed to be used freely outside, but in Venge IO they are.",
        "ratingCount": 2320,
        "thumbnailUrl": "https://images.randplays.com/venge2.png"
    },
    {
        "id": 140,
        "title": "Snake Arena",
        "layout": "landscape",
        "rating": 4,
        "urlkey": "Snake-Arena",
        "gameUrl": "https://game.azgame.io/snake-arena/",
        "category_id": 4,
        "description": "Snake Arena is a thrilling battle for survival. Grow longer, outsmart rivals, and dominate the arena. Slither your way to victory!",
        "ratingCount": 6677,
        "thumbnailUrl": "https://images.randplays.com/snakearena.png"
    },
    {
        "id": 141,
        "title": "1v1soccer.io",
        "layout": "landscape",
        "rating": 4.3,
        "urlkey": "1v1soccer.io",
        "gameUrl": "https://azgames.io/1v1soccerio.embed",
        "category_id": 7,
        "description": "1v1soccer.io is a free online soccer game that offers exciting and dramatic 1v1 soccer matches. In 1v1soccer.io, you will control a single player to face off against a random player in fast-paced soccer matches. Your goal is to score more goals than your opponent to win.",
        "ratingCount": 7423,
        "thumbnailUrl": "https://images.randplays.com/1200x1200.png"
    },
    {
        "id": 142,
        "title": "Smashy Road",
        "layout": "landscape",
        "rating": 4.7,
        "urlkey": "Smashy-Road",
        "gameUrl": "https://azgames.io/smashy-road.embed",
        "category_id": 9,
        "description": "Smashy Road is a single-player arcade car driving game that puts players behind the wheel of a vehicle trying to escape from the police, SWAT teams, tanks, and even helicopters. The chase gets increasingly intense over time; a single mistake or a wrong move will bring it all to an end, and the player is arrested instantly. Stay alive as long as possible to earn points and collect cash scattered during the escape to unlock new vehicles.",
        "ratingCount": 7083,
        "thumbnailUrl": "https://images.randplays.com/smashyroad.png"
    },
    {
        "id": 143,
        "title": "Battle Karts",
        "layout": "landscape",
        "rating": 4.5,
        "urlkey": "Battle-Karts",
        "gameUrl": "https://game.azgame.io/battle-karts/",
        "category_id": 9,
        "description": "Battle Karts Join the ultimate free multiplayer kart battle arena. Drive fast Unleash rockets Create epic explosions. Play now for endless thrills",
        "ratingCount": 3145,
        "thumbnailUrl": "https://images.randplays.com/battlekarts.png"
    },
    {
        "id": 144,
        "title": "Zombie Strike",
        "layout": "landscape",
        "rating": 4.3,
        "urlkey": "Zombie-Strike",
        "gameUrl": "https://game.azgame.io/zombie-strike/",
        "category_id": 4,
        "description": "Zombie Strike is an action-packed first-person shooter survival game that throws players into an intense battle against relentless waves of zombies. Set in confined 3D environments, you have to fight with lots of unusual pixel zombies while exploring secrets and challenges filled in the place. The ultimate goal is to eliminate the hordes of undead, build defenses, survive as long as possible, and craft a time machine. It’s not an easy task; however, the game features a huge arsenal of weapons, different strengths & abilities, to help you fend off enemies.",
        "ratingCount": 2477,
        "thumbnailUrl": "https://images.randplays.com/zombiestrike2.png"
    },
    {
        "id": 145,
        "title": "Crazy Mouse Battle",
        "layout": "landscape",
        "rating": 4.1,
        "urlkey": "Crazy-Mouse-Battle",
        "gameUrl": "https://game.azgame.io/crazy-mouse-battle/",
        "category_id": 4,
        "description": "Crazy Mouse Battle is a fast-paced, single-player battle royale game where you control a wild mouse on a chaotic mission to bump rival mice off the battlefield and claim victory!",
        "ratingCount": 1950,
        "thumbnailUrl": "https://images.randplays.com/crazymousebattle.png"
    },
    {
        "id": 146,
        "title": "Escape Road 2",
        "layout": "landscape",
        "rating": 4.1,
        "urlkey": "Escape-Road-2",
        "gameUrl": "https://game.azgame.io/escape-road-2",
        "category_id": 4,
        "description": "Escape Road 2 is the new version of the famous Escape Road game. Explore the game now!",
        "ratingCount": 1322,
        "thumbnailUrl": "https://images.randplays.com/escape-road-2.png"
    },
    {
        "id": 147,
        "title": "Tap Road",
        "layout": "landscape",
        "rating": 4.2,
        "urlkey": "Tap-Road",
        "gameUrl": "https://azgames.io/tap-road.embed",
        "category_id": 4,
        "description": "Tap Road is an interesting game released by here. In the game, you will control a small ball rolling on a track full of obstacles. Your task is to control the ball so that it overcomes these obstacles and achieves the highest score. The gameplay is simple but requires high concentration and quick reflexes.",
        "ratingCount": 8762,
        "thumbnailUrl": "https://images.randplays.com/taproad.jpg"
    },
    {
        "id": 148,
        "title": "Escape Road City 2",
        "layout": "landscape",
        "rating": 4.8,
        "urlkey": "Escape-Road-City-2",
        "gameUrl": "https://game.azgame.io/escape-road-city-2/",
        "category_id": 4,
        "description": "Escape Road City 2 is the exciting update to the popular action-escape game Escape Road City. Navigate challenging city roads, dodge obstacles, and master your skills to make a daring getaway.",
        "ratingCount": 2838,
        "thumbnailUrl": "https://images.randplays.com/escaperoadcity2.png"
    },
    {
        "id": 149,
        "title": "Escape Road Halloween",
        "layout": "landscape",
        "rating": 4.3,
        "urlkey": "Escape-Road-Halloween",
        "gameUrl": "https://azgames.io/escape-road-halloween.embed",
        "category_id": 4,
        "description": "Escape Road Halloween is a variation of Escape Road game with a Halloween theme. The robbers will escape at night, and the Halloween atmosphere will cover the city.",
        "ratingCount": 4905,
        "thumbnailUrl": "https://images.randplays.com/escaperoadhalloween.png"
    },
    {
        "id": 150,
        "title": "Slope 3",
        "layout": "landscape",
        "rating": 4.4,
        "urlkey": "Slope-3",
        "gameUrl": "https://game.azgame.io/slope-3/",
        "category_id": 4,
        "description": "Are you a big fan of the Slope game series? If so, Slope 3, the new installment, takes the excitement to the next level with vibrant neon visuals and challenging tracks filled with endless obstacles. Take a deep breath, start guiding your ball as far as you can, and achieve best scores to climb the leaderboard!",
        "ratingCount": 6014,
        "thumbnailUrl": "https://images.randplays.com/slope1.png"
    },
    {
        "id": 152,
        "title": "Temple Run 2",
        "layout": "landscape",
        "rating": 4.6,
        "urlkey": "Temple-Run-2",
        "gameUrl": "https://azgames.io/temple-run-2.embed",
        "category_id": 4,
        "description": "Temple Run 2 is the sequel to the popular endless runner game Temple Run. Developed by Imangi Studios in 2013, the game brings players an infinite adventure. The game has the same running gameplay as Temple Run but adds more obstacles and more advanced challenges. A treasure hunter has stolen a statue from an ancient temple. Now you need to help him escape from the angry monkeys.",
        "ratingCount": 7724,
        "thumbnailUrl": "https://images.randplays.com/templerun22.png"
    },
    {
        "id": 153,
        "title": "Jetski Race",
        "layout": "landscape",
        "rating": 4.7,
        "urlkey": "Jetski-Race",
        "gameUrl": "https://game.azgame.io/jetski-race/",
        "category_id": 4,
        "description": "Jetski Race is An exciting arcade racing game! Glide through waves, perform daring flips, and navigate obstacles as you race to the finish. Jump into the action now!",
        "ratingCount": 3560,
        "thumbnailUrl": "https://images.randplays.com/flippyrace.png"
    },
    {
        "id": 154,
        "title": "Snow Road 3D",
        "layout": "landscape",
        "rating": 4.6,
        "urlkey": "Snow-Road-3D",
        "gameUrl": "https://game.azgame.io/snow-road-3d/",
        "category_id": 4,
        "description": "Snow Road 3D is A thrilling 3D racing game! Speed through icy tracks, dodge obstacles, and perform daring stunts in this fast-paced snow adventure. Ready to race?",
        "ratingCount": 2629,
        "thumbnailUrl": "https://images.randplays.com/snowroad3d4.png"
    },
    {
        "id": 155,
        "title": "Snow Road",
        "layout": "landscape",
        "rating": 4,
        "urlkey": "Snow-Road",
        "gameUrl": "https://game.azgame.io/snow-road",
        "category_id": 4,
        "description": "Snow Road - The ultimate skiing game with tons of exciting features. Challenge yourself with adventurous skiing stunts.",
        "ratingCount": 1465,
        "thumbnailUrl": "https://images.randplays.com/snowroad.png"
    },
    {
        "id": 156,
        "title": "Tube Fall",
        "layout": "landscape",
        "rating": 4.9,
        "urlkey": "Tube-Fall",
        "gameUrl": "https://game.azgame.io/tube-fall/",
        "category_id": 4,
        "description": "Tube Fall is 3D endless-run adventure! Take on level after level, flying your adorable Fluffy through danger.",
        "ratingCount": 7441,
        "thumbnailUrl": "https://images.randplays.com/tubefall.png"
    },
    {
        "id": 157,
        "title": "Minecraft",
        "layout": "landscape",
        "rating": 4.9,
        "urlkey": "Minecraft",
        "gameUrl": "https://azgames.io/minecraft.embed",
        "category_id": 4,
        "description": "The creative game Minecraft focuses on construction. Everything is block-based and cartoonish. Post-explosion, players mine or harvest stone, wood, clay, or ore to make blocks. You can play alone or with others to establish a community.",
        "ratingCount": 4808,
        "thumbnailUrl": "https://images.randplays.com/minecraft.png"
    },
    {
        "id": 158,
        "title": "Traffic Rally",
        "layout": "landscape",
        "rating": 4.7,
        "urlkey": "Traffic-Rally",
        "gameUrl": "https://game.azgame.io/traffic-rally/",
        "category_id": 4,
        "description": "Play Traffic Rally - where your driving skills face the ultimate test! Navigate through jam-packed city streets, dodge obstacles, and outmaneuver other vehicles to reach your destination.",
        "ratingCount": 9718,
        "thumbnailUrl": "https://images.randplays.com/trafficrally.png"
    },
    {
        "id": 159,
        "title": "Moto X3M",
        "layout": "landscape",
        "rating": 3.8,
        "urlkey": "Moto-X3M",
        "gameUrl": "https://azgames.io/moto-x3m.embed",
        "category_id": 4,
        "description": "Moto X3M is a fast motorcycle racing game where you tackle difficult obstacles. Madpuffers' game has colorful graphics, realistic vehicle mechanics, and novel gameplay.",
        "ratingCount": 6165,
        "thumbnailUrl": "https://images.randplays.com/moto-x3m.png"
    },
    {
        "id": 160,
        "title": "Geometry Dash",
        "layout": "landscape",
        "rating": 4.9,
        "urlkey": "Geometry-Dash",
        "gameUrl": "https://azgames.io/geometry-dash.embed",
        "category_id": 4,
        "description": "Robert Topala made the exciting rhythm-based platformer game Geometry Dash, which tests your reflexes and balance. You play a square-shaped character in this action-packed adventure. You must navigate a dangerous planet.",
        "ratingCount": 9671,
        "thumbnailUrl": "https://images.randplays.com/logo_of_geometry_dash.svg.png"
    },
    {
        "id": 161,
        "title": "Color Rush",
        "layout": "landscape",
        "rating": 4.3,
        "urlkey": "Color-Rush",
        "gameUrl": "https://game.azgame.io/color-rush/",
        "category_id": 4,
        "description": "Leap into the fast-paced world of Color Rush! Switch colors, dodge obstacles, and master thrilling levels in this addictive action game. Play Now!",
        "ratingCount": 1859,
        "thumbnailUrl": "https://images.randplays.com/colorrush2.png"
    },
    {
        "id": 162,
        "title": "Shooter Hero",
        "layout": "landscape",
        "rating": 4.4,
        "urlkey": "Shooter-Hero",
        "gameUrl": "https://azgames.io/shooter-hero.embed",
        "category_id": 4,
        "description": "Become a shooting master in Shooter Hero game! Aim and shoot to destroy targets, get the highest score and unlock new characters.",
        "ratingCount": 6284,
        "thumbnailUrl": "https://images.randplays.com/shooterhero.jpg"
    },
    {
        "id": 163,
        "title": "Gun Mayhem",
        "layout": "landscape",
        "rating": 4,
        "urlkey": "Gun-Mayhem",
        "gameUrl": "https://azgames.io/gun-mayhem.embed",
        "category_id": 4,
        "description": "Gun Mayhem is a fast-paced 2D shooting platformer game full of challenges, where players need to knock down their opponents off the stage using different firearms before they get pushed off the arena. The game can be played solo or in local multiplayer, but regardless of game mode, Gun Mayhem offers fast-paced combat and chaos. Play the game on here and unlock all the levels in the Campaign mode, or jump into combat in local multiplayer.",
        "ratingCount": 6843,
        "thumbnailUrl": "https://images.randplays.com/gunmayhem2.png"
    },
    {
        "id": 164,
        "title": "Slope",
        "layout": "landscape",
        "rating": 4.3,
        "urlkey": "Slope",
        "gameUrl": "https://azgames.io/slope.embed",
        "category_id": 4,
        "description": "Welcome to Slope, the world of slopes! Another great 3D game that you can't miss!",
        "ratingCount": 5363,
        "thumbnailUrl": "https://images.randplays.com/slope.png"
    },
    {
        "id": 165,
        "title": "Wave Road",
        "layout": "landscape",
        "rating": 4.6,
        "urlkey": "Wave-Road",
        "gameUrl": "https://game.azgame.io/wave-road/",
        "category_id": 4,
        "description": "Wave Road - Avoid obstacles and perform gravity-defying stunts. How far can you fly?",
        "ratingCount": 5284,
        "thumbnailUrl": "https://images.randplays.com/waveroad-11.png"
    },
    {
        "id": 166,
        "title": "Bike Xtreme",
        "layout": "landscape",
        "rating": 3.9,
        "urlkey": "Bike-Xtreme",
        "gameUrl": "https://game.azgame.io/bike-xtreme/",
        "category_id": 4,
        "description": "Bike Xtreme is an exciting racing game. Test your skills with smooth controls and thrilling jumps in this adventure. Ready to ride through rugged terrains?",
        "ratingCount": 9334,
        "thumbnailUrl": "https://images.randplays.com/bikextreme11.png"
    },
    {
        "id": 167,
        "title": "Run 3",
        "layout": "landscape",
        "rating": 4.1,
        "urlkey": "Run-3",
        "gameUrl": "https://azgames.io/run-3.embed",
        "category_id": 4,
        "description": "Run 3 has new characters like The Rabbit and The Duplicator, each with distinct skills. Your task is to control your character to run and collect power cells to unlock new characters and extend your run.However, if you fall off the tunnel, it means game over!",
        "ratingCount": 2814,
        "thumbnailUrl": "https://images.randplays.com/run3thumb.png"
    },
    {
        "id": 168,
        "title": "Bricky Blast",
        "layout": "landscape",
        "rating": 4.1,
        "urlkey": "Bricky-Blast",
        "gameUrl": "https://game.azgame.io/bricky-blast/",
        "category_id": 3,
        "description": "Bricky Blast dive into a vibrant puzzle adventure! Match blocks, solve tricky challenges, and clear levels in this colorful, addictive game. Ready to blast? Play now!",
        "ratingCount": 3071,
        "thumbnailUrl": "https://images.randplays.com/brickyblast.png"
    },
    {
        "id": 169,
        "title": "Overtake X",
        "layout": "landscape",
        "rating": 4,
        "urlkey": "Overtake-X",
        "gameUrl": "https://game.azgame.io/overtake-x/",
        "category_id": 4,
        "description": "Traffic Racer is a high-speed driving game where you weave through endless traffic. Dodge cars, earn cash, and upgrade your ride. Can you become the ultimate road king?",
        "ratingCount": 5913,
        "thumbnailUrl": "https://images.randplays.com/overtakex.png"
    },
    {
        "id": 170,
        "title": "Slope Snowball",
        "layout": "landscape",
        "rating": 4.3,
        "urlkey": "Slope-Snowball",
        "gameUrl": "https://azgames.io/slope-snowball.embed",
        "category_id": 4,
        "description": "Slope SnowBall is an interesting endless running game with a winter theme. Your mission is to roll a snowball on slopes full of obstacles to go as far as possible!",
        "ratingCount": 1350,
        "thumbnailUrl": "https://images.randplays.com/slopesnowball.png"
    },
    {
        "id": 171,
        "title": "Mountain Road",
        "layout": "landscape",
        "rating": 4.2,
        "urlkey": "Mountain-Road",
        "gameUrl": "https://azgames.io/mountain-road.embed",
        "category_id": 4,
        "description": "Mountain Road is a super hot driving game. Players will maneuver the car through steep hills and rough terrain to reach the highest point. Play now!",
        "ratingCount": 6012,
        "thumbnailUrl": "https://images.randplays.com/mountainroad.png"
    },
    {
        "id": 172,
        "title": "Scary Wheels",
        "layout": "landscape",
        "rating": 4.2,
        "urlkey": "Scary-Wheels",
        "gameUrl": "https://game.azgame.io/scary-wheels/",
        "category_id": 4,
        "description": "Scary Wheels isn't your average race! Drive strange vehicles, encounter unexpected traps, and overcome obstacles to reach the finish line as fast as you can.",
        "ratingCount": 7011,
        "thumbnailUrl": "https://images.randplays.com/scarywheels1.png"
    },
    {
        "id": 173,
        "title": "Tunnel Ball",
        "layout": "landscape",
        "rating": 4.7,
        "urlkey": "Tunnel-Ball",
        "gameUrl": "https://game.azgame.io/tunnel-ball/",
        "category_id": 4,
        "description": "Tunnel Ball is a game that controls a ball rolling through challenging obstacles! Collect diamonds, avoid traps and roll as far as possible. Try Now!",
        "ratingCount": 7018,
        "thumbnailUrl": "https://images.randplays.com/tunnelball.png"
    },
    {
        "id": 174,
        "title": "Space Road",
        "layout": "landscape",
        "rating": 4.7,
        "urlkey": "Space-Road",
        "gameUrl": "https://azgames.io/space-road.embed",
        "category_id": 4,
        "description": "Space Road is an interesting game released by here. The game provides players with a colorful and attractive experience. In this game, you will control a spaceship flying through obstacles on challenging roads. Space Road's simple but addictive gameplay necessitates that players be quick and have excellent reflexes to overcome each level.",
        "ratingCount": 4054,
        "thumbnailUrl": "https://images.randplays.com/spaceroad.jpg"
    },
    {
        "id": 175,
        "title": "Vex 3",
        "layout": "landscape",
        "rating": 4.3,
        "urlkey": "Vex-3",
        "gameUrl": "https://azgames.io/vex-3.embed",
        "category_id": 4,
        "description": "Vex 3, the third entry in the famous Vex series, is a challenging and fast-paced 2D platformer game full of twists and turns. Playing as a stickman, players must navigate through a series of levels, aka “Act,” filled with deadly traps, spinning blades, spikes, and more. Run, jump, climb, slide, and perform stunts to dodge these hazardous obstacles and survive. Want to test your agility, patience, and quick reflexes? Vex 3 is a huge challenge. Jump in, show off your skills, and make your way to the upcoming act.",
        "ratingCount": 7221,
        "thumbnailUrl": "https://images.randplays.com/vex3v.jpg"
    },
    {
        "id": 176,
        "title": "Fireboy And Watergirl",
        "layout": "landscape",
        "rating": 3.8,
        "urlkey": "Fireboy-And-Watergirl",
        "gameUrl": "https://azgames.io/fireboy-and-watergirl.embed",
        "category_id": 4,
        "description": "Fireboy & Watergir is a co-op puzzle adventure game. This game lets you play as two characters, Fireboy and Watergirl, and complete difficult levels in the forest castle. Each character has a unique skill. For example, Fireboy can cross through fire but not water, and Watergirl can travel through water but not fire.",
        "ratingCount": 4941,
        "thumbnailUrl": "https://images.randplays.com/fireboy-watergirl-1.png"
    },
    {
        "id": 177,
        "title": "Shooter Sky",
        "layout": "landscape",
        "rating": 4.6,
        "urlkey": "Shooter-Sky",
        "gameUrl": "https://game.azgame.io/shooter-sky/",
        "category_id": 4,
        "description": "Shooter Sky is a crazy and exciting shooting game. Destroy game consoles, phones, animals and more.",
        "ratingCount": 2043,
        "thumbnailUrl": "https://images.randplays.com/shootersky3.png"
    },
    {
        "id": 178,
        "title": "Power Surfer",
        "layout": "landscape",
        "rating": 4.3,
        "urlkey": "Power-Surfer",
        "gameUrl": "https://game.azgame.io/power-surfer/",
        "category_id": 4,
        "description": "Play Power Hover to soar through futuristic skies in this thrilling hoverboard game! Dodge obstacles, collect power-ups, and perform amazing stunts. Click here to play!",
        "ratingCount": 3391,
        "thumbnailUrl": "https://images.randplays.com/powersurfer1.png"
    },
    {
        "id": 179,
        "title": "Escape Vehicles",
        "layout": "landscape",
        "rating": 3.9,
        "urlkey": "Escape-Vehicles",
        "gameUrl": "https://azgames.io/escape-vehicles.embed",
        "category_id": 4,
        "description": "Escape Vehicles is the #1 action game for speed racers. Drive hard, escape the police and upgrade your car.",
        "ratingCount": 9826,
        "thumbnailUrl": "https://images.randplays.com/escapevehicles.png"
    },
    {
        "id": 180,
        "title": "Kong Adventure",
        "layout": "landscape",
        "rating": 4.1,
        "urlkey": "Kong-Adventure",
        "gameUrl": "https://azgames.io/kong-adventure.embed",
        "category_id": 4,
        "description": "Kong Adventure is a colorful and attractive endless running game. You will play the role of a mischievous monkey, overcoming dangerous obstacles to collect as many bananas as possible. This is one of the most favorite games on mobile platforms.",
        "ratingCount": 1956,
        "thumbnailUrl": "https://images.randplays.com/kong-adventure.png"
    },
    {
        "id": 181,
        "title": "Dark Loop",
        "layout": "landscape",
        "rating": 4.7,
        "urlkey": "Dark-Loop",
        "gameUrl": "https://game.azgame.io/dark-loop/",
        "category_id": 4,
        "description": "Dark Loop is a quirky puzzle game with a twist! Solve the same level repeatedly with new creative solutions. Challenge your mind and enjoy endless fun!",
        "ratingCount": 6305,
        "thumbnailUrl": "https://images.randplays.com/darkloop.png"
    },
    {
        "id": 182,
        "title": "Ziggy Road",
        "layout": "landscape",
        "rating": 4,
        "urlkey": "Ziggy-Road",
        "gameUrl": "https://game.azgame.io/ziggy-road/",
        "category_id": 4,
        "description": "Ziggy Road is a minimalist single-player arcade game released on here in March 2025. In the game, players control a small ball rolling along an endless narrow zig-zagging platform without falling off the edges. Each turn on the path and gems collected along the way earn points. The farther the ball travels, the higher scores you earn. Play the game now and see how far you can drive your ball in this simple yet challenging gameplay.",
        "ratingCount": 6654,
        "thumbnailUrl": "https://images.randplays.com/ziggyroad1.png"
    },
    {
        "id": 183,
        "title": "Tap Rush",
        "layout": "landscape",
        "rating": 4.3,
        "urlkey": "Tap-Rush",
        "gameUrl": "https://game.azgame.io/tap-rush/",
        "category_id": 4,
        "description": "Think you have lightning-fast reflexes and sharp concentration? Put them to the test in Tap Rush. Play it now and see how far you can guide the ball.",
        "ratingCount": 4355,
        "thumbnailUrl": "https://images.randplays.com/taprush2.png"
    },
    {
        "id": 184,
        "title": "Egg Race",
        "layout": "landscape",
        "rating": 4.5,
        "urlkey": "Egg-Race",
        "gameUrl": "https://game.azgame.io/egg-race/",
        "category_id": 4,
        "description": "Eggy Car is a game about driving a wobbly car carrying a precious egg! Balance, collect coins and see how far you can go. Click here to play!",
        "ratingCount": 9814,
        "thumbnailUrl": "https://images.randplays.com/eggrace1.png"
    },
    {
        "id": 185,
        "title": "Drift Road",
        "layout": "landscape",
        "rating": 4.5,
        "urlkey": "Drift-Road",
        "gameUrl": "https://azgames.io/drift-road.embed",
        "category_id": 4,
        "description": "Become the king of Drift Boss cars! Drift on winding trails, perform skillful drifts and conquer all challenges.",
        "ratingCount": 8002,
        "thumbnailUrl": "https://images.randplays.com/driftroad.png"
    },
    {
        "id": 186,
        "title": "Run 3D",
        "layout": "landscape",
        "rating": 4.2,
        "urlkey": "Run-3D",
        "gameUrl": "https://azgames.io/run-3d.embed",
        "category_id": 4,
        "description": "Run 3D is an endless platform runner game set in outer space featuring a fast-moving character running through a twisting 3D tunnel full of gaps, traps, and sharp turns. Your objective is to control this character run as far as possible without falling off the rotatable tunnels. Quick reflexes, precision, and steady focus are key to success in this fast-paced gameplay. Dodge obstacles and run smoothly, unlock new levels, earn coins, and travel the space as far as you can.",
        "ratingCount": 9568,
        "thumbnailUrl": "https://images.randplays.com/512x5121.png"
    },
    {
        "id": 187,
        "title": "Loop Breakout",
        "layout": "landscape",
        "rating": 4.9,
        "urlkey": "Loop-Breakout",
        "gameUrl": "https://game.azgame.io/loop-breakout/",
        "category_id": 4,
        "description": "Loop Breakout is a puzzle-platformer adventure game where players take the role of the stickman, a protagonist, who tries to escape from prison. The game is full of complex challenges, featuring heavily guarded security systems with lots of spikes, vigilant wardens, traps, etc. These make escaping feel like an impossible task. There are a total of 180 levels, each with a unique set of obstacles that require fast reflexes, skills, and creative problem-solving to overcome.",
        "ratingCount": 4832,
        "thumbnailUrl": "https://images.randplays.com/loopbreakout1.png"
    },
    {
        "id": 188,
        "title": "Highway Heat",
        "layout": "landscape",
        "rating": 4.6,
        "urlkey": "Highway-Heat",
        "gameUrl": "https://game.azgame.io/highway-heat/",
        "category_id": 4,
        "description": "Highway Heat is a thrilling fast-paced arcade car racing game featuring stunning 3D realistic visuals, different game modes, various environments, and huge vehicle upgrade choices to explore. In this high-speed game, players control powerful cars, racing through various tracks, avoiding collisions, and earning in-game money to unlock great customization options. Ready to take the wheel, skillfully dodge traffic, get rewards, and unlock your dream cars? Play Highway Heat on here now.",
        "ratingCount": 3457,
        "thumbnailUrl": "https://images.randplays.com/highwayheat1.png"
    },
    {
        "id": 189,
        "title": "Zombie Rising",
        "layout": "landscape",
        "rating": 4.4,
        "urlkey": "Zombie-Rising",
        "gameUrl": "https://game.azgame.io/zombie-rising/",
        "category_id": 4,
        "description": "Zombie Rising is a third-person shooting game set in a dark, zombie-infested city, where players must defend themselves by defeating waves of pixel zombies coming from all directions. As the game progresses, hordes of undead become more and more intense and aggressive. So, get prepared and arm yourself with a variety of weapons, ammo, and other resources to efficiently battle waves of relentless zombies and stay alive.",
        "ratingCount": 1789,
        "thumbnailUrl": "https://images.randplays.com/zombierising1.png"
    },
    {
        "id": 190,
        "title": "Sprunki Jump",
        "layout": "landscape",
        "rating": 4.5,
        "urlkey": "Sprunki-Jump",
        "gameUrl": "https://game.azgame.io/sprunki-jump/",
        "category_id": 4,
        "description": "Sprunki Jump lets you leap through colorful worlds, avoiding obstacles and collecting rewards. Experience endless adventure and test your jumping skills!",
        "ratingCount": 6576,
        "thumbnailUrl": "https://images.randplays.com/sprunkijump.png"
    },
    {
        "id": 191,
        "title": "Blocky Overtake X",
        "layout": "landscape",
        "rating": 4.1,
        "urlkey": "Blocky-Overtake-X",
        "gameUrl": "https://game.azgame.io/blocky-overtake-x/",
        "category_id": 4,
        "description": "Blocky Overtake X is the ultimate blocky driving challenge! Speed through blocky landscapes, avoid blocky crashes, and become the blocky road champion. Experience the blocky thrill!",
        "ratingCount": 8512,
        "thumbnailUrl": "https://images.randplays.com/512x512-logo.png"
    },
    {
        "id": 192,
        "title": "Ragdoll Playground",
        "layout": "landscape",
        "rating": 4.5,
        "urlkey": "Ragdoll-Playground",
        "gameUrl": "https://game.azgame.io/ragdoll-playground/",
        "category_id": 4,
        "description": "Ragdoll Playground is a 2D physics-based sandbox game where players can spawn a wide range of objects and experiment with them in different vast open environments. There’s no specific goal or storyline; it’s mainly about exploring and experimenting. Whether it’s testing the effect of different objects and tools, crafting something, or simply exploring how items interact with the game’s environment, the game gives players full control.",
        "ratingCount": 3832,
        "thumbnailUrl": "https://images.randplays.com/ragdollplayground.png"
    },
    {
        "id": 193,
        "title": "Fury Chase",
        "layout": "landscape",
        "rating": 4,
        "urlkey": "Fury-Chase",
        "gameUrl": "https://game.azgame.io/fury-chase/",
        "category_id": 4,
        "description": "Furry Chase is a high-speed arcade car driving game released on here in April 2025. In the game, players play as a getaway driver. The mission is to pick up crew members after a heist and deliver them to safety while evading relentless police chases. Also, many obstacles line the road; bumping into any of them or getting hit by police cars will reduce your HP. The game ends once HP hits zero. The game gets increasingly tougher with more police and vehicles joining the chase, making survival a true test of skill.",
        "ratingCount": 1626,
        "thumbnailUrl": "https://images.randplays.com/furychase.png"
    },
    {
        "id": 194,
        "title": "Breakout Racing",
        "layout": "landscape",
        "rating": 3.9,
        "urlkey": "Breakout-Racing",
        "gameUrl": "https://game.azgame.io/breakout-racing/",
        "category_id": 4,
        "description": "Breakout Racing is an action-packed driving game! Race against the police, collect coins, and unlock cool cars. Can you help the panda make a clean getaway? Play now and find out!",
        "ratingCount": 4635,
        "thumbnailUrl": "https://images.randplays.com/breakoutracing1.png"
    },
    {
        "id": 195,
        "title": "Orbit Dash",
        "layout": "landscape",
        "rating": 4.7,
        "urlkey": "Orbit-Dash",
        "gameUrl": "https://game.azgame.io/orbit-dash/",
        "category_id": 4,
        "description": "Orbit Dash is a fun, addictive single-player casual, arcade game featuring simple one-button gameplay. The game challenges players to guide a rainbow-colored line through a vertically obstacle-filled course by swinging it from point to point. The goal is to go as far as possible and score the highest. Hold the line and release it at the right time to swing; crashing into walls or obstacles while swinging around the anchor point will end your line.",
        "ratingCount": 8294,
        "thumbnailUrl": "https://images.randplays.com/orbitdash.png"
    },
    {
        "id": 196,
        "title": "Stellar Burner",
        "layout": "landscape",
        "rating": 4.7,
        "urlkey": "Stellar-Burner",
        "gameUrl": "https://game.azgame.io/stellar-burner/",
        "category_id": 4,
        "description": "Stellar Burner is a high-speed spaceflight game that puts players in control of high-performance spacecraft flying through a series of increasingly difficult courses. There are different zones with multiple stages in each. Players’ goal is straightforward: fly the ship through the entire course, dodge incoming obstacles, and reach the end of each stage. As players progress, the game becomes much harder with faster speeds, tighter gaps, and a lot more obstacles taking place.",
        "ratingCount": 8565,
        "thumbnailUrl": "https://images.randplays.com/stellarburner1.png"
    },
    {
        "id": 197,
        "title": "Dino Dash 3D",
        "layout": "landscape",
        "rating": 4.4,
        "urlkey": "Dino-Dash-3D",
        "gameUrl": "https://game.azgame.io/dino-dash-3d/",
        "category_id": 4,
        "description": "Dino Dash 3D is the classic T-Rex game you love now in beautiful and immersive 3D. How long can you survive in this game?",
        "ratingCount": 7941,
        "thumbnailUrl": "https://images.randplays.com/dinodash3d1.png"
    },
    {
        "id": 198,
        "title": "Slope 2",
        "layout": "landscape",
        "rating": 4.2,
        "urlkey": "Slope-2",
        "gameUrl": "https://game.azgame.io/slope-2/",
        "category_id": 4,
        "description": "Slope 2 is back with thrilling new obstacles! Test your reflexes, dodge traps, and race down faster than ever. Can you survive the challenge?",
        "ratingCount": 41234,
        "thumbnailUrl": "https://images.randplays.com/slope2.png"
    },
    {
        "id": 199,
        "title": "Wyrmdash",
        "layout": "landscape",
        "rating": 3.8,
        "urlkey": "Wyrmdash",
        "gameUrl": "https://game.azgame.io/wyrmdash/",
        "category_id": 4,
        "description": "Wyrmdash isn’t a traditional fairy tale where princesses wait to be saved; it's instead a fast-paced adventure where the princess herself takes control, riding a mighty dragon companion on a quest for revenge. She burns everything on her way and fights off all rigid bosses. Play the game on here now, level up, and engage in epic boss battles.",
        "ratingCount": 4011,
        "thumbnailUrl": "https://images.randplays.com/wyrmdash.png"
    },
    {
        "id": 200,
        "title": "Wing Smash",
        "layout": "landscape",
        "rating": 4.6,
        "urlkey": "Wing-Smash",
        "gameUrl": "https://game.azgame.io/wing-smash/",
        "category_id": 4,
        "description": "Wing Smash is an arcade single-player endless flight runner game where players pilot a fighter airplane through stunning 3D environments on a mission to bomb enemy bases. With landscapes filled with lots of hazards and relentless enemy defenses, the game constantly pushes your reflexes to the limit. Ready to fly deep into enemy territory and face powerful bosses? Play Wing Smash for free on here now!",
        "ratingCount": 4234,
        "thumbnailUrl": "https://images.randplays.com/wingsmash.png"
    },
    {
        "id": 201,
        "title": "Cuby Road",
        "layout": "landscape",
        "rating": 4.3,
        "urlkey": "Cuby-Road",
        "gameUrl": "https://azgames.io/cuby-road.embed",
        "category_id": 4,
        "description": "Cuby Road is a newly released addictive endless running game. The player navigates a cube across a hostile and obstacle-filled area to the greatest extent possible.",
        "ratingCount": 8135,
        "thumbnailUrl": "https://images.randplays.com/cubyroad.png"
    },
    {
        "id": 202,
        "title": "subway Santa",
        "layout": "auto",
        "rating": 4,
        "urlkey": "subway-Santa",
        "gameUrl": "https://azgames.io/subway-santa.embed",
        "category_id": 4,
        "description": "",
        "ratingCount": 8974,
        "thumbnailUrl": "https://images.randplays.com/subwaysanta.png"
    },
    {
        "id": 203,
        "title": "Cuby Road Halloween",
        "layout": "landscape",
        "rating": 4.4,
        "urlkey": "Cuby-Road-Halloween",
        "gameUrl": "https://azgames.io/cuby-road-halloween.embed",
        "category_id": 4,
        "description": "Cuby Road Halloween is a variation of Cuby Road game with a Halloween theme. To the greatest extent feasible, the player moves a cube across a hostile, obstacle-filled environment.",
        "ratingCount": 1461,
        "thumbnailUrl": "https://images.randplays.com/cubyroadhalloween.png"
    },
    {
        "id": 204,
        "title": "Temple Runner",
        "layout": "portrait",
        "rating": 5,
        "urlkey": "Temple-Runner",
        "gameUrl": "https://azgames.io/temple-runner.embed",
        "category_id": 4,
        "description": "While making your way through the temple and jungle, you'll have to dive, jump and slide to make your way past obstacles. Finish exciting challenges to gain",
        "ratingCount": 6389,
        "thumbnailUrl": "https://images.randplays.com/templerun2.png"
    },
    {
        "id": 205,
        "title": "Flying Kong",
        "layout": "landscape",
        "rating": 4.2,
        "urlkey": "Flying-Kong",
        "gameUrl": "https://game.azgame.io/flying-kong/",
        "category_id": 4,
        "description": "Let’s take on the role of a Flying Kong in a thrilling jungle adventure! Dodge obstacles, collect bananas, and chase high scores while enjoying endless hilarious moments. Jump in and prove your skills!",
        "ratingCount": 8559,
        "thumbnailUrl": "https://images.randplays.com/flyingkong1.png"
    },
    {
        "id": 206,
        "title": "Crazy Animal City",
        "layout": "landscape",
        "rating": 4.9,
        "urlkey": "Crazy-Animal-City",
        "gameUrl": "https://game.azgame.io/crazy-animal-city/",
        "category_id": 4,
        "description": "Crazy Animal City is a 3D animal simulator featuring lots of wild chaos and mayhem. It’s set in an expansive open-world environment where players take on the role of various wild animals, including lions, stags, wolves, bunnies, bears, and even a T-Rex. The primary object is to cause as much mayhem as possible. However, the SWAT team is always there to stop the rampage. Watch out for them; otherwise, you can get caught quickly! Play free online on here today.",
        "ratingCount": 4628,
        "thumbnailUrl": "https://images.randplays.com/crazyanimalcity2.png"
    },
    {
        "id": 207,
        "title": "Town Run",
        "layout": "landscape",
        "rating": 4.5,
        "urlkey": "Town-Run",
        "gameUrl": "https://azgames.io/town-run.embed",
        "category_id": 4,
        "description": "Town Run is an exciting endless running game in which you will play as mischievous cat Tom and other lovely friends on an adventure to chase the cunning raccoon thief. Your mission in Town Run is very simple: run as fast as possible and collect as much gold as possible while avoiding obstacles such as vehicles, trash cans, and traps set by the raccoon thief. At the same time, you need to use power-ups to increase speed and overcome difficult challenges.",
        "ratingCount": 5464,
        "thumbnailUrl": "https://images.randplays.com/town-run.jpg"
    },
    {
        "id": 208,
        "title": "Chicken Jockey Combat",
        "layout": "landscape",
        "rating": 4.9,
        "urlkey": "Chicken-Jockey-Combat",
        "gameUrl": "https://game.azgame.io/chicken-jockey-combat/",
        "category_id": 4,
        "description": "Set in a pixelated world invaded by waves of zombies, Chicken Jockey Combat is a fast-paced, first-person survival shooter game where players defend themselves and their base against relentless zombie attacks. The ultimate goal is to build a time machine to escape the zombie apocalypse and save people. But it’s never an easy task, as hordes of zombies get progressively harder, with the presence of plenty of unusual bosses with special abilities. Gear up and ready to face off against endless waves of the undead! Play the game on here today.",
        "ratingCount": 3437,
        "thumbnailUrl": "https://images.randplays.com/chickenjockeycombat1.png"
    },
    {
        "id": 209,
        "title": "Mars Jump",
        "layout": "landscape",
        "rating": 4,
        "urlkey": "Mars-Jump",
        "gameUrl": "https://game.azgame.io/mars-jump/",
        "category_id": 4,
        "description": "Mars Jump is a casual yet challenging skill-based platformer where players hop from platform to platform using a jetpack. Ready to fly around the red planet and explore the breathtaking Martian landscape? Jump in and traverse Mars' unique environment as far as you can. But be aware: the gravity is low, and all imperfect landings lead to crashing.",
        "ratingCount": 8794,
        "thumbnailUrl": "https://images.randplays.com/marsjump1.png"
    },
    {
        "id": 210,
        "title": "Ski Frenzy",
        "layout": "landscape",
        "rating": 4.7,
        "urlkey": "Ski-Frenzy",
        "gameUrl": "https://game.azgame.io/ski-frenzy/",
        "category_id": 4,
        "description": "Ski Frenzy is a thrilling, endless runner experience featuring fast-paced skiing action. In the game, players control Sven or Evana skiing down treacherous slopes on a mission to escape a relentless avalanche. Along the way, the character can hitch the ride on different vehicles and animals like penguins and eagles, each offering unique assistance in the escape. Ready to show off your skills? Play Ski Frenzy on here now.",
        "ratingCount": 5658,
        "thumbnailUrl": "https://images.randplays.com/skifrenzy1.png"
    },
    {
        "id": 211,
        "title": "Spear Warzone",
        "layout": "landscape",
        "rating": 4.5,
        "urlkey": "Spear-Warzone",
        "gameUrl": "https://game.azgame.io/spear-warzone/",
        "category_id": 4,
        "description": "Spear Warzone is a 2D stickman-based action game where players control a stickman warrior armed with a spear, countering various enemies such as archers, swordsmen, javelin throwers, and magicians. Its gameplay is simple yet engaging, mainly revolving around throwing spears at enemies while dodging incoming attacks. As you progress, more enemies will appear — and they’ll grow stronger, requiring sharper accuracy and quicker reflexes to outsmart them.",
        "ratingCount": 9909,
        "thumbnailUrl": "https://images.randplays.com/spearwazone.png"
    },
    {
        "id": 212,
        "title": "2048 Italian Brainrot",
        "layout": "landscape",
        "rating": 4.3,
        "urlkey": "2048-Italian-Brainrot",
        "gameUrl": "https://game.azgame.io/2048-italian-brainrot/",
        "category_id": 4,
        "description": "The classic 2048 puzzle just got a hilarious twist! Welcome to 2048 Italian Brainrot, where instead of merging numbers, you combine tiles of viral Italian Brainrot characters to unlock new ones. From Tung Tung Tung Sahur to Chimpanzini Bananini and more, get ready to meet the funniest memes around. Start merging and see how far your Brainrot collection can go!",
        "ratingCount": 4567,
        "thumbnailUrl": "https://images.randplays.com/2048italian3.png"
    },
    {
        "id": 213,
        "title": "Golf Hit",
        "layout": "landscape",
        "rating": 4.2,
        "urlkey": "Golf-Hit",
        "gameUrl": "https://game.azgame.io/golf-hit/",
        "category_id": 4,
        "description": "Golf Hit is an entertaining golf simulator game that challenges players to hit the ball as far as possible, even reaching Mars, with just one shot. Earn coins for every hit. Of course, the farther the ball goes, the higher score you earn; aim to score a birdie, an eagle, or an albatross to multiply your score. Get ready to jump into the challenges and become a golf king. Enjoy Golf Hit on here and see how far your ball can reach.",
        "ratingCount": 1111,
        "thumbnailUrl": "https://images.randplays.com/golfhit2.png"
    },
    {
        "id": 214,
        "title": "Head Soccer 2024",
        "layout": "landscape",
        "rating": 4.2,
        "urlkey": "Head-Soccer-2024",
        "gameUrl": "https://azgames.io/head-soccer-2024.embed",
        "category_id": 7,
        "description": "Head Soccer 2024 is a unique soccer game, the players are transformed into characters with big round heads and special superpowers. The simple, funny but challenging game will give players who are fans of this king sport moments of relaxation and entertainment.",
        "ratingCount": 8856,
        "thumbnailUrl": "https://images.randplays.com/thumbnail_90x90.jpg"
    },
    {
        "id": 215,
        "title": "Head Basketball",
        "layout": "landscape",
        "rating": 4.8,
        "urlkey": "Head-Basketball",
        "gameUrl": "https://azgames.io/head-basketball.embed",
        "category_id": 8,
        "description": "Head Basketball is a fun sports game featuring unique big-headed characters competing in exciting 1v1 and 2v2 matches. The game offers different modes that allow players to enjoy solo challenges and team up or play against friends for a more thrilling gaming experience. Ready to run, jump, dash, aim, shoot, dunk, and make so many baskets to defeat the opponents? Click to play now and see how many points you can score in a match.",
        "ratingCount": 3943,
        "thumbnailUrl": "https://images.randplays.com/headbasketball.png"
    },
    {
        "id": 216,
        "title": "Basket Random",
        "layout": "landscape",
        "rating": 5,
        "urlkey": "Basket-Random",
        "gameUrl": "https://azgames.io/basket-random.embed",
        "category_id": 9,
        "description": "Basket Random is a fun two-player basketball sports game. The object is to score as many goals as possible to beat your opponent and get more points.",
        "ratingCount": 1148,
        "thumbnailUrl": "https://images.randplays.com/basketrandom.jpeg"
    },
    {
        "id": 217,
        "title": "Basketball Stars",
        "layout": "landscape",
        "rating": 4.4,
        "urlkey": "Basketball-Stars",
        "gameUrl": "https://azgames.io/basketball-stars.embed",
        "category_id": 9,
        "description": "Basketball Stars is an exciting basketball game that is sure to get you excited. Developed by Madpuffers, the game is a playground where you play as the most iconic soccer players in history. Whether you play alone or with friends, Basketball Stars promises to bring a dynamic and engaging experience.",
        "ratingCount": 1915,
        "thumbnailUrl": "https://images.randplays.com/basketballstarsgamelogo2.png"
    },
    {
        "id": 218,
        "title": "Hockey Random",
        "layout": "landscape",
        "rating": 4.4,
        "urlkey": "Hockey-Random",
        "gameUrl": "https://game.azgame.io/hockey-random/",
        "category_id": 9,
        "description": "Hockey Random is a fun and chaotic hockey game. With a two-player mode, you can challenge friends in unpredictable, fast-paced matches where the gameplay is random.",
        "ratingCount": 5128,
        "thumbnailUrl": "https://images.randplays.com/hockeyrandom1.png"
    },
    {
        "id": 219,
        "title": "Knock Balls",
        "layout": "auto",
        "rating": 4,
        "urlkey": "Knock-Balls",
        "gameUrl": "https://azgames.io/knock-balls.embed",
        "category_id": 9,
        "description": "Knock Balls is a fun ball shooting game. In Knock Balls, your mission is to shoot balls to destroy structures. You will have to calculate the force and angle of the shot accurately to destroy the entire structure. Each level will be a new challenge with increasingly complex structures and more obstacles.",
        "ratingCount": 9898,
        "thumbnailUrl": "https://images.randplays.com/knockballs.png"
    },
    {
        "id": 220,
        "title": "Speed Shooter",
        "layout": "landscape",
        "rating": 4.2,
        "urlkey": "Speed-Shooter",
        "gameUrl": "https://game.azgame.io/speed-shooter/",
        "category_id": 10,
        "description": "Speed Shooter - Dive into this thrilling FPS! Precision and quick thinking are your best allies. Are you up for the challenge? Play now and test your skills!",
        "ratingCount": 6103,
        "thumbnailUrl": "https://images.randplays.com/speedshooter.png"
    },
    {
        "id": 221,
        "title": "Bricky Break",
        "layout": "auto",
        "rating": 5,
        "urlkey": "Bricky-Break",
        "gameUrl": "https://game.azgame.io/bricky-break/",
        "category_id": 9,
        "description": "Bricky Break is a fun and simple arcade blast! Launch balls, break bricks, and collect more balls for a chain reaction. Relaxing gameplay, challenging levels. Play now!",
        "ratingCount": 8820,
        "thumbnailUrl": "https://images.randplays.com/brickybreak.png"
    },
    {
        "id": 222,
        "title": "Rebound Shooter",
        "layout": "landscape",
        "rating": 4.9,
        "urlkey": "Rebound-Shooter",
        "gameUrl": "https://game.azgame.io/rebound-shooter/",
        "category_id": 10,
        "description": "Rebound Shooter is a fun and action-packed game where you shoot zombies in unique ways. Test your aim, solve puzzles, and eliminate the undead with precision!",
        "ratingCount": 6790,
        "thumbnailUrl": "https://images.randplays.com/reboundshooter.png"
    },
    {
        "id": 223,
        "title": "Blocky Hunter",
        "layout": "landscape",
        "rating": 4.5,
        "urlkey": "Blocky-Hunter",
        "gameUrl": "https://game.azgame.io/blocky-hunter/",
        "category_id": 10,
        "description": "Zombies are coming wave after wave while boss monsters are challenging you to take down. Ready to equip powerful weapons and support items and go for the hunt? Defeating boss zombies is no easy task, but the effort is well worth it—amazing rewards await once you eliminate them!",
        "ratingCount": 6493,
        "thumbnailUrl": "https://images.randplays.com/blockyhunter.png"
    },
    {
        "id": 224,
        "title": "Traffic Road",
        "layout": "landscape",
        "rating": 4.3,
        "urlkey": "Traffic-Road",
        "gameUrl": "https://azgames.io/traffic-road.embed",
        "category_id": 7,
        "description": "Play Traffic Road! High-speed racing game in traffic jam city.",
        "ratingCount": 2092,
        "thumbnailUrl": "https://images.randplays.com/trafficroad.png"
    },
    {
        "id": 225,
        "title": "Drive Mad",
        "layout": "landscape",
        "rating": 3.8,
        "urlkey": "Drive-Mad",
        "gameUrl": "https://azgames.io/drive-mad.embed",
        "category_id": 9,
        "description": "Drive Mad is a fun car driving game where you drive silly cars moving on diverse terrains filled with obstacles. The goal is to reach the finish line safely and level up. Gear up, jump into the driver’s seat, and conquer a bunch of challenging levels now for free!",
        "ratingCount": 7983,
        "thumbnailUrl": "https://images.randplays.com/drivemad.png"
    },
    {
        "id": 226,
        "title": "Traffic Rider",
        "layout": "landscape",
        "rating": 3.9,
        "urlkey": "Traffic-Rider",
        "gameUrl": "https://azgames.io/traffic-rider.embed",
        "category_id": 1,
        "description": "Traffic Rider is a single-player motorcycle driving game that puts players in the driver’s seat with a first-person perspective, riding through heavy traffic, dodging other vehicles, and earning rewards to spend on upgrades and new motorbike purchases. The game features about 30 unlockable motorcycle models with detailed, realistic visuals. Which one is your most favorite? Jump in, perform your best, and buy your dream vehicle. Enjoy the game on Az.io now!",
        "ratingCount": 5639,
        "thumbnailUrl": "https://images.randplays.com/trafficrider.png"
    },
    {
        "id": 227,
        "title": "Retro Bowl",
        "layout": "landscape",
        "rating": 4,
        "urlkey": "Retro-Bowl",
        "gameUrl": "https://azgames.io/retro-bowl.embed",
        "category_id": 8,
        "description": "Retro Bowl by New Star Games is an American football game. Can you win with your dream team? Run an NFL franchise, expand your roster, and handle press to satisfy your team and fans.games",
        "ratingCount": 3245,
        "thumbnailUrl": "https://images.randplays.com/retro-bowl.jpg"
    },
    {
        "id": 228,
        "title": "Snow Rider 3D",
        "layout": "landscape",
        "rating": 4.6,
        "urlkey": "Snow-Rider-3D",
        "gameUrl": "https://azgames.io/snow-rider-3d.embed",
        "category_id": 7,
        "description": "Welcome to the ultimate snowboarding adventure with Snow Rider 3D! Let's conquer the icy slopes. Snow Rider 3D is a dramatic and exciting snowboarding simulation game! You can freely perform beautiful runways!",
        "ratingCount": 7311,
        "thumbnailUrl": "https://images.randplays.com/snow-rider-3d.png"
    },
    {
        "id": 229,
        "title": "Turbo Street",
        "layout": "landscape",
        "rating": 4.8,
        "urlkey": "Turbo-Street",
        "gameUrl": "https://game.azgame.io/turbo-street/",
        "category_id": 7,
        "description": "Looking to experience the thrill of motorbike racing professionally? If so, Turbo Street is really worth a try. Steer your bike skillfully, be the first to reach the finish line to win the race, and earn money to upgrade your favorite motorbikes; jump in now!",
        "ratingCount": 7816,
        "thumbnailUrl": "https://images.randplays.com/turbostreet.png"
    },
    {
        "id": 230,
        "title": "Wacky Flip",
        "layout": "landscape",
        "rating": 3.8,
        "urlkey": "Wacky-Flip",
        "gameUrl": "https://game.azgame.io/wacky-flip/",
        "category_id": 9,
        "description": "Wacky Flip is a skill-based simulator game that combines parkour, gymnastics, and ragdoll physics to create thrilling stunt-based gameplay. Let’s jump in, perform extreme flips and tricks in various urban environments, and become the ultimate backflip athlete. Play the game for free on here now!",
        "ratingCount": 7149,
        "thumbnailUrl": "https://images.randplays.com/wackyflip.png"
    },
    {
        "id": 231,
        "title": "Escape Road",
        "layout": "landscape",
        "rating": 4.3,
        "urlkey": "Escape-Road",
        "gameUrl": "https://azgames.io/escape-road.embed",
        "category_id": 9,
        "description": "Have you ever dreamed of becoming a reckless bank robber? Escape Road will take you on a dramatic and thrilling adventure. As a robber who has just successfully carried out a heist, you must face the police's fierce pursuit. Can you escape the siege and take the loot with you?",
        "ratingCount": 23399,
        "thumbnailUrl": "https://images.randplays.com/escaperoad.png"
    },
    {
        "id": 232,
        "title": "Drift Hunters",
        "layout": "landscape",
        "rating": 4.6,
        "urlkey": "Drift-Hunters",
        "gameUrl": "https://azgames.io/drift-hunters.embed",
        "category_id": 7,
        "description": "Drift Hunters is a free-to-play 3D drift car game. Want to race on various challenging yet exciting racetracks, customize your supercars, and, more importantly, experience the art of drifting? Gear up, start your drive, deliver exceptional drifts, and earn your highest scores now!",
        "ratingCount": 2293,
        "thumbnailUrl": "https://images.randplays.com/drifthunters.jpg"
    },
    {
        "id": 233,
        "title": "Traffic Jam 3D",
        "layout": "landscape",
        "rating": 4.3,
        "urlkey": "Traffic-Jam-3D",
        "gameUrl": "https://azgames.io/traffic-jam-3d.embed",
        "category_id": 9,
        "description": "Traffic Jam 3D is an exciting fast-paced car game that offers an immersive driving experience while challenging players to race and navigate at high speed through busy traffic and avoid collisions. Any crashes can lead to an end, forcing you to restart the level or the race. That’s how the game puts your skills and quick reflexes to test.",
        "ratingCount": 7024,
        "thumbnailUrl": "https://images.randplays.com/trafficjam3d.jpeg"
    },
    {
        "id": 234,
        "title": "Escape Road City",
        "layout": "landscape",
        "rating": 4,
        "urlkey": "Escape-Road-City",
        "gameUrl": "https://azgames.io/escape-road-city.embed",
        "category_id": 9,
        "description": "Escape Road City is a thrilling car chase game on the streets! Control your car, overcome all obstacles and escape from the police chase.",
        "ratingCount": 9240,
        "thumbnailUrl": "https://images.randplays.com/icon.png"
    },
    {
        "id": 235,
        "title": "Drift Boss",
        "layout": "auto",
        "rating": 4.2,
        "urlkey": "Drift-Boss",
        "gameUrl": "https://azgames.io/drift-boss.embed",
        "category_id": 9,
        "description": "A lighthearted one-click driving game, Drift Boss has you maneuver your automobile around challenging turns and over bumps to reach an unlimited end!",
        "ratingCount": 6124,
        "thumbnailUrl": "https://images.randplays.com/drift-boss.png"
    },
    {
        "id": 236,
        "title": "Eggy Car",
        "layout": "landscape",
        "rating": 4.1,
        "urlkey": "Eggy-Car",
        "gameUrl": "https://azgames.io/eggy-car.embed",
        "category_id": 9,
        "description": "Eggy Car is an entertaining driving game where you control a car carrying a loose egg and navigate over bumpy, hilly roads. Your task is to transport this fragile egg as far as you can while keeping it safe. The game ends instantly when the egg falls out and breaks.",
        "ratingCount": 1901,
        "thumbnailUrl": "https://images.randplays.com/eggycar.jpg"
    },
    {
        "id": 237,
        "title": "Stickman Hook",
        "layout": "auto",
        "rating": 3.9,
        "urlkey": "Stickman-Hook",
        "gameUrl": "https://azgames.io/stickman-hook.embed",
        "category_id": 9,
        "description": "Stickman Hook is a fun physics-based casual game where players control a stickman to swing through many challenging levels. A level is completed when you reach the finish line, unlocking a new level. You’ll have to start over if you fall before reaching the endpoint.",
        "ratingCount": 8137,
        "thumbnailUrl": "https://images.randplays.com/stickmanhook.jpg"
    },
    {
        "id": 238,
        "title": "Sugar Sugar",
        "layout": "landscape",
        "rating": 4.9,
        "urlkey": "Sugar-Sugar",
        "gameUrl": "https://azgames.io/sugar-sugar.embed",
        "category_id": 9,
        "description": "Sugar Sugar is an engaging puzzle game. Draw lines on the screen to fill your cups. So sweet!",
        "ratingCount": 6977,
        "thumbnailUrl": "https://images.randplays.com/sugarsugar1.png"
    },
    {
        "id": 239,
        "title": "Brain Lines",
        "layout": "landscape",
        "rating": 4.1,
        "urlkey": "Brain-Lines",
        "gameUrl": "https://game.azgame.io/brain-lines/",
        "category_id": 9,
        "description": "Brain Lines is a drawing-based puzzle game that challenges your creativity and problem-solving skills with clever physics puzzles.",
        "ratingCount": 9478,
        "thumbnailUrl": "https://images.randplays.com/brainlines.png"
    },
    {
        "id": 240,
        "title": "Suika Game",
        "layout": "auto",
        "rating": 4.2,
        "urlkey": "Suika-Game",
        "gameUrl": "https://azgames.io/suika-game.embed",
        "category_id": 2,
        "description": "Greetings and welcome to the Suika Game! This game is aesthetically pleasing and engaging.In this game, the objective is to merge fruits that are the same. The objective of the game is to generate watermelons and amass the best achievable score.Let's engage in the Suika Game as it not only provides amusement. Additionally, it aids in the development of your strategic thinking abilities and enhances your proficiency in space management.",
        "ratingCount": 7455,
        "thumbnailUrl": "https://images.randplays.com/suikagame.png"
    },
    {
        "id": 241,
        "title": "Tetris",
        "layout": "landscape",
        "rating": 3.9,
        "urlkey": "Tetris",
        "gameUrl": "https://azgames.io/tetris.embed",
        "category_id": 2,
        "description": "Tetris is a classic puzzle game where players control falling geometric shapes called Tetriminos. You need to rotate and arrange them to create complete horizontal lines.",
        "ratingCount": 7840,
        "thumbnailUrl": "https://images.randplays.com/tetristhumb.png"
    },
    {
        "id": 242,
        "title": "2048",
        "layout": "auto",
        "rating": 4.2,
        "urlkey": "2048",
        "gameUrl": "https://azgames.io/2048.embed",
        "category_id": 2,
        "description": "2048 is an easy and fun puzzle game. Your task is to use your arrow keys to move the cells. When two cells with the same number touch, they merge into one.When you merge cells, you earn points. So earn more points along with your goal of reaching the magic number 2048.",
        "ratingCount": 6836,
        "thumbnailUrl": "https://images.randplays.com/2048.jpg"
    },
    {
        "id": 243,
        "title": "Trap the cat",
        "layout": "landscape",
        "rating": 4.1,
        "urlkey": "Trap-the-cat",
        "gameUrl": "https://azgames.io/trap-the-cat.embed",
        "category_id": 9,
        "description": "Don’t let the cat escape easily. That’s your mission in Trap The Cat. It may sound simple; however, the cat is clever, and without strategic moves, it’s hard to prevent it from escaping. Play now and try to block all its escape routes.",
        "ratingCount": 9662,
        "thumbnailUrl": "https://images.randplays.com/trap-the-cat.jpg"
    },
    {
        "id": 244,
        "title": "Jelly Hop",
        "layout": "landscape",
        "rating": 4.4,
        "urlkey": "Jelly-Hop",
        "gameUrl": "https://game.azgame.io/jelly-hop/",
        "category_id": 9,
        "description": "Jelly Hop is an addictive, endless jumping game. Jump higher, survive longer and never give up!",
        "ratingCount": 8801,
        "thumbnailUrl": "https://images.randplays.com/jellyhop1.png"
    },
    {
        "id": 245,
        "title": "2048 Drop",
        "layout": "landscape",
        "rating": 4.5,
        "urlkey": "2048-Drop",
        "gameUrl": "https://game.azgame.io/2048-drop/",
        "category_id": 3,
        "description": "Game 2048 Drop challenges you to merge chips strategically to create the ultimate number 2048. Dive into this addictive game!",
        "ratingCount": 5018,
        "thumbnailUrl": "https://images.randplays.com/2048drop2.png"
    },
    {
        "id": 246,
        "title": "Block Slide",
        "layout": "auto",
        "rating": 4.3,
        "urlkey": "Block-Slide",
        "gameUrl": "https://game.azgame.io/block-slide/",
        "category_id": 9,
        "description": "Block Slide is the ultimate puzzle adventure! Slide colorful blocks and clear challenging obstacles in hundreds of fun and creative levels. Play now!",
        "ratingCount": 6690,
        "thumbnailUrl": "https://images.randplays.com/blockslide1.png"
    },
    {
        "id": 248,
        "title": "Sprunki",
        "layout": "landscape",
        "rating": 5,
        "urlkey": "Sprunki",
        "gameUrl": "https://azgames.io/sprunki.embed",
        "category_id": 9,
        "description": "Play Sprunki Incredibox! Join the Incredibox community and create amazing music! With the Sprunki mod, you can mix music, share and connect with music lovers around the world.",
        "ratingCount": 2893,
        "thumbnailUrl": "https://images.randplays.com/sprunki.png"
    },
    {
        "id": 249,
        "title": "Crossy Road",
        "layout": "landscape",
        "rating": 4.3,
        "urlkey": "Crossy-Road",
        "gameUrl": "https://azgames.io/crossy-road.embed",
        "category_id": 9,
        "description": "Crossy Road is an entertaining endless arcade hopper game, featuring simple yet fun and challenging gameplay. In the game, you’ll take control of your adorable character, guide it to safely cross roads, rivers, train tracks, and other obstacles and earn points. The farther you travel, the more points you’ll earn. The game ends if your character is hit by vehicles on the streets or falls into the water. Play Crossy Road now, enjoy its vibrant visuals, travel so far, and unlock a vast collection of pretty characters.",
        "ratingCount": 6288,
        "thumbnailUrl": "https://images.randplays.com/crossyroad1.png"
    },
    {
        "id": 250,
        "title": "Omnom Jump",
        "layout": "landscape",
        "rating": 4.2,
        "urlkey": "Omnom-Jump",
        "gameUrl": "https://game.azgame.io/om-nom-jump/",
        "category_id": 9,
        "description": "Om Nom Jump is a game where you jump and stack blocks to reach new heights! Get On Nom as high as possible to avoid the starving sharks.",
        "ratingCount": 3760,
        "thumbnailUrl": "https://images.randplays.com/omnomjump11.png"
    },
    {
        "id": 251,
        "title": "Bitlife",
        "layout": "auto",
        "rating": 4.1,
        "urlkey": "Bitlife",
        "gameUrl": "https://azgames.io/bitlife.embed",
        "category_id": 9,
        "description": "BitLife is a text-based life simulation game. Here you can make every decision about your life, from birth to death. Each choice will create a unique and unpredictable life story.",
        "ratingCount": 7939,
        "thumbnailUrl": "https://images.randplays.com/bitlifegamebanner1.png"
    },
    {
        "id": 252,
        "title": "Bottle Jump",
        "layout": "auto",
        "rating": 4.1,
        "urlkey": "Bottle-Jump",
        "gameUrl": "https://game.azgame.io/bottle-jump/",
        "category_id": 9,
        "description": "Challenge your precision and agility and enjoy endless fun in Bottle Jump. The objective is straightforward: flip a plastic bottle and land it upright on different objects without letting it fall. Press and hold the left mouse button to control how far the bottle will jump, then release the mouse to make it fly and flip. This may sound simple, but there are no piece-of-cake jumps here! Play the game on here now and see just how far your skills can take you.",
        "ratingCount": 9414,
        "thumbnailUrl": "https://images.randplays.com/bottlejump2.png"
    },
    {
        "id": 253,
        "title": "Tiny Fishing",
        "layout": "landscape",
        "rating": 4.5,
        "urlkey": "Tiny-Fishing",
        "gameUrl": "https://azgames.io/tiny-fishing.embed",
        "category_id": 9,
        "description": "Fishing is a basic but addicting fishing game. You play a fisherman trying to catch the most fish. The goal is to get rich and enhance your fishing boat.",
        "ratingCount": 4251,
        "thumbnailUrl": "https://images.randplays.com/tinyfishing.jpg"
    },
    {
        "id": 254,
        "title": "Duck Life",
        "layout": "landscape",
        "rating": 4,
        "urlkey": "Duck-Life",
        "gameUrl": "https://azgames.io/duck-life.embed",
        "category_id": 9,
        "description": "Duck Life is an amazing adventure and training game where you farm and race ducks. The game starts with a tornado destroying your farm and leaving a duck egg... Develop this duck to make money and restore the farm.",
        "ratingCount": 1012,
        "thumbnailUrl": "https://images.randplays.com/ducklife.png"
    },
    {
        "id": 255,
        "title": "Pacman 30th Anniversary",
        "layout": "landscape",
        "rating": 3.8,
        "urlkey": "Pacman-30th-Anniversary",
        "gameUrl": "https://azgames.io/pacman-30th-anniversary.embed",
        "category_id": 7,
        "description": "Game graphics and sounds are improved in this game. Three game types and achievements enable players advance.",
        "ratingCount": 9312,
        "thumbnailUrl": "https://images.randplays.com/pacman.jpg"
    },
    {
        "id": 256,
        "title": "Slope Cyber",
        "layout": "landscape",
        "rating": 4.5,
        "urlkey": "Slope-Cyber",
        "gameUrl": "https://azgames.io/slope-cyber.embed",
        "category_id": 1,
        "description": "Slope Cyber is an amazing Cyberpunk 2077-themed variation of the Slope game. Take control of a robotic ball and compete to get the best score by racing through neon-lit streets and dodging obstacles!",
        "ratingCount": 6521,
        "thumbnailUrl": "https://images.randplays.com/thumbnail_256_2.png"
    },
    {
        "id": 257,
        "title": "Slope Emoji 2",
        "layout": "landscape",
        "rating": 3.8,
        "urlkey": "Slope-Emoji-2",
        "gameUrl": "https://azgames.io/slope-emoji-2.embed",
        "category_id": 1,
        "description": "Slope Emoji 2 is the next version of the addictive game Slope Emoji. In this second version, the game brings new and more interesting features to players. With simple but addictive gameplay, fun graphics and many attractive new features, Slope Emoji 2 quickly became one of the most popular games today.",
        "ratingCount": 3669,
        "thumbnailUrl": "https://images.randplays.com/thumb_256x256.png"
    },
    {
        "id": 258,
        "title": "Slope Legacy",
        "layout": "landscape",
        "rating": 4.1,
        "urlkey": "Slope-Legacy",
        "gameUrl": "https://azgames.io/slope-legacy.embed",
        "category_id": 1,
        "description": "Slope Legacy is a fun spin-off of the endless runner game Slope, featuring a retro-futuristic aesthetic and new features. The game is primarily about guiding a ball down endless slopes. This version has been upgraded with additional challenges and ball skins!",
        "ratingCount": 6783,
        "thumbnailUrl": "https://images.randplays.com/slop_legaxy.png"
    },
    {
        "id": 259,
        "title": "Slope Emoji",
        "layout": "landscape",
        "rating": 4.1,
        "urlkey": "Slope-Emoji",
        "gameUrl": "https://azgames.io/slope-emoji.embed",
        "category_id": 1,
        "description": "Slope Emoji is an addictive game with simple gameplay and funny graphics. The player's task is to control an emoji ball rolling quickly on a slope full of obstacles. Players will experience exciting and dramatic moments of entertainment.",
        "ratingCount": 3906,
        "thumbnailUrl": "https://images.randplays.com/thumb-256-3.png"
    },
    {
        "id": 260,
        "title": "Slope spooky",
        "layout": "landscape",
        "rating": 4.5,
        "urlkey": "Slope-spooky",
        "gameUrl": "https://azgames.io/slope-spooky.embed",
        "category_id": 1,
        "description": "With creepy graphics and thrilling sounds, you will have to dodge obstacles and collect points while exploring the mysterious world.\n\nPlayers control a Halloween ball and race down spooky slopes. The goal? It's the same. That is to reach the longest distance on the rolling journey. The adventure is still endless. And you need to keep the spooky ball on the platform.\n\nThere are many creepy elements like ghosts, witches, bats, pumpkins, skulls, and more. That takes the rolling challenge both thrilling and exciting. \n\nAll of that makes Slope Spooky the perfect choice for those who love thrills and challenges. Get ready for breathtaking action!",
        "ratingCount": 7183,
        "thumbnailUrl": "https://images.randplays.com/slopespooky.png"
    },
    {
        "id": 261,
        "title": "Slope Gear",
        "layout": "landscape",
        "rating": 4.1,
        "urlkey": "Slope-Gear",
        "gameUrl": "https://azgames.io/slope-gear.embed",
        "category_id": 1,
        "description": "Slope Gear is a fun new version of the game Slope with steampunk graphics. Help the ball go down hills, around tricky hurdles, and into power-ups as you try to get the highest score!",
        "ratingCount": 5195,
        "thumbnailUrl": "https://images.randplays.com/layer-1583.png"
    },
    {
        "id": 262,
        "title": "Papa's Freezeria",
        "layout": "landscape",
        "rating": 4.2,
        "urlkey": "Papas-Freezeria",
        "gameUrl": "https://azgames.io/papas-freezeria.embed",
        "category_id": 7,
        "description": "Are you interested in pursuing a career as the renowned manager of an ice cream shop? That's right, Papa's Freezeria is just what you need! This is a fun and realistic business game about running an ice cream shop.",
        "ratingCount": 3428,
        "thumbnailUrl": "https://images.randplays.com/papasfreezeria.png"
    },
    {
        "id": 265,
        "title": "Love Tester",
        "layout": "landscape",
        "rating": 4.2,
        "urlkey": "Love-Tester",
        "gameUrl": "https://game.randplays.com/iframe.html?id=147453",
        "category_id": 11,
        "description": "Love Tester is a game of fun, letting you analyze the strength of your feelings based on names. \n\nHere's what it offers:\n* Easy to play;\n* nice-looking visuals.\n",
        "ratingCount": 1795,
        "thumbnailUrl": "https://images.randplays.com/p_147453.png"
    },
    {
        "id": 271,
        "title": "Ball Sort Puzzle - Color Sort",
        "layout": "portrait",
        "rating": 4.2,
        "urlkey": "Ball-Sort-Puzzle-Color-Sort",
        "gameUrl": "https://game.randplays.com/iframe.html?id=193301",
        "category_id": 9,
        "description": "Ball Sort Puzzle - Color Sort is a challenging puzzle game that will keep you entertained for hours! Sort the colored balls in the tubes until all of the same-hued balls are in the same tube. A brain-teasing game that is both tough and relaxing!\n\nFEATURES:\n - Control with just one finger.\n - Multiple unique levels.\n - Completely free and easy to play.\n - Use hints for the best move to solve the puzzle.\n - There are no penalties or time limits, so you can play Ball Sort Puzzle - Color Sort whenever you want!",
        "ratingCount": 10002,
        "thumbnailUrl": "https://images.randplays.com/p_193301.png"
    },
    {
        "id": 273,
        "title": "Surf GO: Online parkour, CS GO bhop and surf in 3D",
        "layout": "landscape",
        "rating": 4.4,
        "urlkey": "Surf-GO-Online-parkour-CS-GO-bhop-and-surf-in-3D",
        "gameUrl": "https://game.randplays.com/iframe.html?id=203069",
        "category_id": 14,
        "description": "Surf GO: Online Parkour, CS GO Bhop and Surf in 3D is a dynamic online game that combines elements of parkour and bhop. Players can showcase their skills by jumping on ramps, performing tricks, and proving their mastery of the game.\n\nIf you enjoy collecting CS GO skins, you're in for a treat! The game offers an extensive collection of cases and over 250 skins with varying rarity levels, from common to legendary.\n\nKey features of Surf GO include:\n- Multiplayer mode for competitive gameplay\n- Stunning graphics optimized for all devices\n- Case simulator for easy collection\n- Over 300 achievements to unlock\n- 50+ parkour levels for bhop and surfing, plus endless mode\n- Customizable weapons and equipment, including karambit and butterfly knives\n- Dozens of cases to open in the store\n- Realistic bhop and surf mechanics reminiscent of CS GO\n- Levels with a neon twist for added flair\n- Regular updates for fresh content and improvements\n\nImmerse yourself in the world of Surf GO, conquer levels, collect skins, and experience the thrill of online parkour like never before.",
        "ratingCount": 41145,
        "thumbnailUrl": "https://images.randplays.com/p_203069.png"
    },
    {
        "id": 276,
        "title": "Geometry Dash 2.2: Arrow",
        "layout": "landscape",
        "rating": 3.8,
        "urlkey": "Geometry-Dash-2.2-Arrow",
        "gameUrl": "https://game.randplays.com/iframe.html?id=213713",
        "category_id": 13,
        "description": "Geometry Dash 2.2: Arrow\nThis game is all about guiding an arrow through a challenging cave filled with obstacles.\n\nThe objective is to reach the portal at the end of the cave while avoiding various traps and spikes. The game consists of 13 levels, each progressively more difficult than the last.",
        "ratingCount": 469,
        "thumbnailUrl": "https://images.randplays.com/p_213713.png"
    },
    {
        "id": 279,
        "title": "Geometry Dash: Wave Challenge",
        "layout": "landscape",
        "rating": 3.5,
        "urlkey": "Geometry-Dash-Wave-Challenge",
        "gameUrl": "https://game.randplays.com/iframe.html?id=227352",
        "category_id": 13,
        "description": "Beat the game without hitting those obstacles!\n\nIn this game, you’ll find:\n* an enjoyable musical backdrop;\n* a gameplay that needs swift reflexes and accurate movement;\n* 8 levels that keep getting harder;\n* easy-to-understand design with simple graphics.\n\nUse all your skills and put yourself to the test!",
        "ratingCount": 388,
        "thumbnailUrl": "https://images.randplays.com/p_227352.png"
    },
    {
        "id": 285,
        "title": "Geometry Dash: clicker and levels",
        "layout": "landscape",
        "rating": 4,
        "urlkey": "Geometry-Dash-clicker-and-levels",
        "gameUrl": "https://game.randplays.com/iframe.html?id=245949",
        "category_id": 9,
        "description": "💫 «Geometry Dash: clicker and levels» is a game that fuses elements of clicker games with arcade action. You can have endless fun building up your account until the numbers are off the charts! As you rack up points, you'll unlock levels of varying difficulty and discover a range of challenges that span the genres of \"runner\" and \"platformer\". Plus, there's the exciting mini-game «Connection», where you can compete for the top spot and claim bragging rights!\n🦾 Unleash your potential in this game set in the expansive world of Geometry Dash. Boost your score, unlock new levels, and rise from obscurity to become a «Demon»!\n🏆 Accomplish feats in the game and claim accolades as you strive for greatness. Showcase your prowess and let others marvel at your accomplishments.\n😎 By logging in, you gain access to the leaderboards which rank players by their total points, completed levels, and earned achievements. Aim for the summit, outperform your rivals, and witness the envy in their eyes as they attempt to catch up!",
        "ratingCount": 2082,
        "thumbnailUrl": "https://images.randplays.com/p_245949.png"
    },
    {
        "id": 287,
        "title": "Ball Run 2048: merge number",
        "layout": "auto",
        "rating": 4.3,
        "urlkey": "Ball-Run-2048-merge-number",
        "gameUrl": "https://game.randplays.com/iframe.html?id=256065",
        "category_id": 13,
        "description": "Ball Run 2048: merge number is a ball game where you have to make the numbers on the balls bigger.\n\nControl the balls with your finger to make them merge with other balls of the same number!\nEach time the balls are combined, they get bigger and change color.\nThe number on the ball starts from 2, when it merges with a ball of the same number, the numbers are added and grows up to a maximum of 2048.\nEven children can complete the game, but it is very difficult to reach the goal at 2048.\n\nControl the balls so it does not fall off the course or hit obstacles and try to reach 2048!\nCan you make a rainbow-colored 2048 ball?",
        "ratingCount": 11648,
        "thumbnailUrl": "https://images.randplays.com/p_256065.png"
    },
    {
        "id": 288,
        "title": "Obby but You're on a Bike",
        "layout": "landscape",
        "rating": 3.8,
        "urlkey": "Obby-but-Youre-on-a-Bike",
        "gameUrl": "https://game.randplays.com/iframe.html?id=257923",
        "category_id": 13,
        "description": "Ever tried Obby? It's a popular game that tests your agility and problem-solving skills through a series of challenges. But now, there's a twist – you're on a bike! This means you can breeze past obstacles and reach new worlds in no time.\n\nEach world has its own set of obstacles, making every run unique. You'll need to master jumps, tight turns, and quick reflexes to succeed. The thrill of combining biking with parkour is unlike anything you've experienced before.\n\nYour progress is tracked, and you can see how you rank against other players worldwide. Can you claim the top spot? The only things that matter are your skills and effort.\n\nDive into \"Obby but You're on a Bike\" for an exhilarating adventure!",
        "ratingCount": 29068,
        "thumbnailUrl": "https://images.randplays.com/p_257923.png"
    },
    {
        "id": 290,
        "title": "Melon Sandbox",
        "layout": "landscape",
        "rating": 4.4,
        "urlkey": "Melon-Sandbox",
        "gameUrl": "https://game.randplays.com/iframe.html?id=260481",
        "category_id": 17,
        "description": "Let your imagination run wild with a vast selection of items at your disposal: from melee weapons and firearms to barrels! Engage in thrilling races using armored vehicles, experiment with mystical syringes, and witness the unpredictable outcomes for your characters.\n\nPreserve your masterpieces and showcase them to the gaming community. Additionally, download modifications crafted by fellow players to infuse your gaming universe with fresh elements. \n\nIn Melon Sandbox, the only limits are those of your imagination – let it lead you to endless adventures.",
        "ratingCount": 65550,
        "thumbnailUrl": "https://images.randplays.com/p_260481.png"
    },
    {
        "id": 293,
        "title": "Deadly Descent",
        "layout": "landscape",
        "rating": 4.3,
        "urlkey": "Deadly-Descent",
        "gameUrl": "https://game.randplays.com/iframe.html?id=274415",
        "category_id": 14,
        "description": "\"Deadly Descent\" is an exciting game where you drive a car down a mountain filled with obstacles. The goal is to reach the finish line without crashing into any of the obstacles, which would cause your car to break down. This game is perfect for those who enjoy playing games where cars can be destroyed in various ways. Now you can play it on your phone or computer for free!\n\nIn this game, you have control of a car that can be damaged and you need to drive carefully to avoid crashing. Despite having advanced physics and realistic graphics, the game doesn't require a lot of resources from your device and provides a realistic driving experience on any device.\n\nCompete with other players on unique tracks! Each track has a record table, and each player automatically records their best result — the farthest distance your car traveled on the track.\n\nStart your adventure now!",
        "ratingCount": 94720,
        "thumbnailUrl": "https://images.randplays.com/p_274415.png"
    },
    {
        "id": 294,
        "title": "Fast tap",
        "layout": "auto",
        "rating": 4.3,
        "urlkey": "Fast-tap",
        "gameUrl": "https://game.randplays.com/iframe.html?id=274911",
        "category_id": 9,
        "description": "Fast Tap is an exhilarating action game that tests your speed and accuracy. With every second counting, only the quickest players can achieve high scores.\n\nFast Tap offers a chance to demonstrate your skills and go head-to-head with other players, whether you're a newcomer or a seasoned gamer.\nPut your talent to the test, rack up points, and climb the ranks on the leaderboard to claim the title of ultimate victor!\n\nThis game is compatible with many devices, so anyone can give it a try.",
        "ratingCount": 15,
        "thumbnailUrl": "https://images.randplays.com/p_274911.png"
    },
    {
        "id": 304,
        "title": "Race Survival: Arena King",
        "layout": "landscape",
        "rating": 4.4,
        "urlkey": "Race-Survival-Arena-King",
        "gameUrl": "https://game.randplays.com/iframe.html?id=288720",
        "category_id": 13,
        "description": "This is a race for survival in a hexagonal arena.\nAs you speed across the arena, the hexagons fall away behind you.\nShow off your skills by steering and jumping to stay on the constantly changing arena.\nRam into your opponents to send them plummeting into water, lava or acid.\nCollect golden crowns for each defeated opponent, gather coins, and perform tricks to unlock new cars.\nIf you finish in first place, you'll enter an arena with more opponents; if you fall to the bottom of the leaderboard, you'll face fewer.",
        "ratingCount": 41101,
        "thumbnailUrl": "https://images.randplays.com/p_288720.png"
    },
    {
        "id": 305,
        "title": "Obby online with friends: Draw and Jump!",
        "layout": "landscape",
        "rating": 4.1,
        "urlkey": "Obby-online-with-friends-Draw-and-Jump",
        "gameUrl": "https://game.randplays.com/iframe.html?id=289722",
        "category_id": 13,
        "description": "Embark on an extraordinary journey into the realm of parkour gaming with the popular Roblox experience, Obby! Prepare for an exhilarating adventure filled with gravity-defying leaps and ingenious puzzles. This game not only challenges your parkour skills but also invites you to collaborate with friends, creating custom platforms and navigating through obstacles. Together, you'll compete for top spots on the leaderboard and strive to become the ultimate parkour champion.\n\nKey Features:\n- Team up with friends in multiplayer mode\n- Engaging blend of platforming and drawing elements\n- Intriguing puzzles and hurdles\n- User-friendly controls for addictive gameplay\n- Leaderboard competition for supremacy\n\nIf you crave adventure and enjoy playing with friends online, this is the game for you. Immerse yourself in the captivating world of Obby from Roblox and carve your path to victory! Don't miss out on this opportunity to immerse yourself in an unforgettable journey of parkour and camaraderie!",
        "ratingCount": 13503,
        "thumbnailUrl": "https://images.randplays.com/p_289722.png"
    },
    {
        "id": 308,
        "title": "Evolution of Omega Nuggets: Clicker",
        "layout": "landscape",
        "rating": 4.5,
        "urlkey": "Evolution-of-Omega-Nuggets-Clicker",
        "gameUrl": "https://game.randplays.com/iframe.html?id=297909",
        "category_id": 9,
        "description": "Dive into the fascinating realm of the clicker game, \"Evolution of Omega Nuggets: Clicker\"! \n\nYou'll encounter the renowned Omega Nugget characters who are eager to join you on your gaming adventure! 🐔 Accumulate the in-game currency, nuggets, 💰 and unlock new characters, each bringing their own unique advantages! 🍗\n\nThe more a character levels up, the more impressive they become to look at! 🌟 Ready to witness the peak development of these Omega Nuggets? Then start playing right away! 🤩",
        "ratingCount": 1340,
        "thumbnailUrl": "https://images.randplays.com/p_297909.png"
    },
    {
        "id": 312,
        "title": "A Difficult Game About Climbing",
        "layout": "landscape",
        "rating": 3.7,
        "urlkey": "A-Difficult-Game-About-Climbing",
        "gameUrl": "https://game.randplays.com/iframe.html?id=307581",
        "category_id": 9,
        "description": "Welcome to A Difficult Game About Climbing! In this engaging game, you'll use the mouse to control the climber's hands to conquer a massive and perilous mountain full of surprises. Be cautious on slippery surfaces as you make your way to the top. Eternal glory and a beautiful reward await those climbers who can reach the summit!\n\nGame Features:\n\nPunishing but not impossible gameplay. The more you practice, the better your results.\nEvery obstacle is thoughtfully designed, without any filler.\nFocused gameplay without distracting elements.\nNo violence. You cannot die or get injured, but one mistake can erase all your progress... and that might be even worse.\nClimb, slip, fall. Again and again.\nEndless trials.\nBut not:\nLegs... For some reason, you cannot use your legs.\nDeveloper's Note:\nThe game is inspired by Getting Over it with Bennett Foddy, which in turn pays homage to an even older game, Sexy Hiking by Jazzuo.",
        "ratingCount": 1261,
        "thumbnailUrl": "https://images.randplays.com/p_307581.png"
    },
    {
        "id": 313,
        "title": "I'm on Observation Duty",
        "layout": "landscape",
        "rating": 3.8,
        "urlkey": "Im-on-Observation-Duty",
        "gameUrl": "https://game.randplays.com/iframe.html?id=311869",
        "category_id": 2,
        "description": "Immerse yourself in an atmosphere of tense anticipation and paranormal events in this unique horror-survival game. Watch the surveillance cameras and identify anomalies before terrifying things go too far! Experience the tension of needing to react quickly and eliminate threats before the fateful 6 am. Can you withstand this trial?\n\nDon't let the anomaly limit be exceeded and hold out until dawn. Closely monitor the surveillance cameras, react to the slightest deviations, and eliminate any anomalies detected. Miss more than three, and the game will be lost. Time is ticking, and anomalies are multiplying - can you stand up against the paranormal nightmare until the sun rises?",
        "ratingCount": 261,
        "thumbnailUrl": "https://images.randplays.com/p_311869.png"
    },
    {
        "id": 316,
        "title": "Obby: Mini-Games",
        "layout": "landscape",
        "rating": 4.3,
        "urlkey": "Obby-Mini-Games",
        "gameUrl": "https://game.randplays.com/iframe.html?id=335573",
        "category_id": 13,
        "description": "Obby: Mini-Games - play against other players and win Cups! Triumph in each mode and stand on the golden winner's pedestal!\n\n🔴 MODES 🔴\n\n🚀 PARKOUR 🚀\nComplete colorful levels on the parkour map and reach the end!\n\n🎯 COLORFUL FLOOR 🎯\nIn this mode, you need to step on tiles whose color is displayed at the top of the screen.\n\n🎯 GLASS BRIDGE 🎯\nAnd in this mode, you need to choose which glass tile to jump on, but one will break, and the other will remain intact.\n\n🎯 FALLING TILES 🎯\nIn this mode, you have to run across tiles, but there's a condition: the tiles you've already run on will fall down and disappear after a second. So, be careful.\n\n☀️ RAIN OF BLOCKS ☀️\nThis mode will unlock as you progress through the game!",
        "ratingCount": 24985,
        "thumbnailUrl": "https://images.randplays.com/p_335573.png"
    },
    {
        "id": 320,
        "title": "Thorn and Balloons",
        "layout": "landscape",
        "rating": 3.6,
        "urlkey": "Thorn-and-Balloons",
        "gameUrl": "https://game.randplays.com/iframe.html?id=350180",
        "category_id": 9,
        "description": "«Thorn and Balloons» is an exciting casual puzzle game that will keep you entertained! In this game, you need to control a thorn ball and use the physics of ricocheting to burst all the balloons. Show off your quick thinking and strategic skills!\n\nKey aspects:\nBrain-Teasing Levels: Each level is a tricky puzzle that encourages creativity and out-of-the-box thinking. \nEasygoing and Engaging: With soothing music and smooth gameplay, this game is perfect for relaxation.\nMental Boost: The game helps enhance logical reasoning and spatial awareness.\nArtistic Design: The minimalist and stylish visuals create a unique ambiance for the game.",
        "ratingCount": 262,
        "thumbnailUrl": "https://images.randplays.com/p_350180.png"
    },
    {
        "id": 321,
        "title": "Twerk Race 3D",
        "layout": "auto",
        "rating": 4.1,
        "urlkey": "Twerk-Race-3D",
        "gameUrl": "https://game.randplays.com/iframe.html?id=352374",
        "category_id": 13,
        "description": "Start the game with a little boost! Grab some calorie-rich snacks and give your avatar a curvier look! \nWin the Twerk showdown and become a star of the stage! Every race has different levels, colorful 3D design and tons of fun surprises. Put your skills to the test and enjoy the exciting and entertaining gameplay!",
        "ratingCount": 12169,
        "thumbnailUrl": "https://images.randplays.com/p_352374.png"
    },
    {
        "id": 327,
        "title": "Schoolboy Escape: Stealth Runaway",
        "layout": "landscape",
        "rating": 4,
        "urlkey": "Schoolboy-Escape-Stealth-Runaway",
        "gameUrl": "https://game.randplays.com/iframe.html?id=374315",
        "category_id": 4,
        "description": "«Schoolboy Escape: Stealth Runaway» is a captivating first-person stealth horror game that plunges you into a world of thrills, suspense, and chills. The protagonist is a young boy whose strict parents have confined him to the house with the task of finishing his homework. But instead of doing the boring homework, he dreams about sneaking out to meet up with his friends. Your objective is to aid the boy in carrying out this brave plan, avoiding encounters with his parents and finding all possible ways to escape from the house.\n\nKey features of the horror adventure «Schoolboy Escape»: \n— Three acts, in each of them the schoolboy needs to escape different places. Get away from home, school, and even from a fisherman!\n— Atmosphere of horror: Beware of any unexpected noise, creak, or rustle. Keep a sharp eye on the dark corridors of the old house. \n— Interactive house: Investigate every nook of the house and become a true detective.",
        "ratingCount": 11962,
        "thumbnailUrl": "https://images.randplays.com/p_374315.png"
    },
    {
        "id": 331,
        "title": "Getting Over It Classic",
        "layout": "landscape",
        "rating": 1.9,
        "urlkey": "Getting-Over-It-Classic",
        "gameUrl": "https://game.randplays.com/iframe.html?id=380739",
        "category_id": 13,
        "description": "«Getting Over It Classic» is an action-packed game that puts your grit and determination to the test. Similar to popular physics-based puzzles, this game offers a unique way of moving around, requiring focus and precision.\n\nAs you navigate the game, you’ll find yourself tackling intense climbing challenges where one wrong move might send you sliding back. This game is perfect for those who love a challenge and are seeking something fresh and engaging.\n\nWith multiple levels and ever-changing hurdles, «Getting Over It Classic» keeps the excitement alive. And if you want to challenge your friends, why not share your progress and see who can climb to greater heights?",
        "ratingCount": 17,
        "thumbnailUrl": "https://images.randplays.com/p_380739.png"
    },
    {
        "id": 337,
        "title": "Plants Vs Zombie Hybrid Story Mod",
        "layout": "landscape",
        "rating": 4.6,
        "urlkey": "Plants-Vs-Zombie-Hybrid-Story-Mod",
        "gameUrl": "https://game.randplays.com/iframe.html?id=388246",
        "category_id": 9,
        "description": "Enter a whole new reality of «Plants vs. Zombies»! This isn't your regular game; it's an exciting blend of the old and the new!\n\nHere you not only protect your home from zombies using plants, but you also create one-of-a-kind hybrid plants that combine the best traits of two or more original plants.\n\nThese hybrids give you countless ways to defeat the new waves of zombies, which have become smarter, stronger, and more cunning!\n\nWhat's fresh in the game:\n\n* 10 new plants – get your garden filled with fresh and unique green helpers!\n* New and unique zombies – be ready for surprises because the enemies have become even more diverse.\n* Daily missions – finish them and get a prize!\n* Upgraded game modes – they're now even more fun.\n* A new place to explore – discover and get ready for cool battles.\n* Bug fixes – the game is now even smoother and better.",
        "ratingCount": 20699,
        "thumbnailUrl": "https://images.randplays.com/p_388246.png"
    },
    {
        "id": 343,
        "title": "Squid Game 2: Mini Games",
        "layout": "landscape",
        "rating": 3.6,
        "urlkey": "Squid-Game-2-Mini-Games",
        "gameUrl": "https://game.randplays.com/iframe.html?id=400931",
        "category_id": 9,
        "description": "«Squid Game 2: Mini Games» is a fascinating and nerve-wracking game. Its unique mini-games test your agility, quick thinking and strategy skills.\n\nIn this game, you'll face many dangerous obstacles where every decision could mean the difference between life and death. Can you avoid traps, think on your feet and outsmart your opponents to become the ultimate winner?",
        "ratingCount": 7785,
        "thumbnailUrl": "https://images.randplays.com/p_400931.png"
    },
    {
        "id": 344,
        "title": "Sprunki Playground",
        "layout": "landscape",
        "rating": 4.5,
        "urlkey": "Sprunki-Playground",
        "gameUrl": "https://game.randplays.com/iframe.html?id=405184",
        "category_id": 9,
        "description": "\"Spunky Playground\" is an exhilarating new game mode where you can orchestrate epic battles between spunky characters. Unleash your creativity as you equip your spunkies with an array of imaginative weapons and watch the action unfold.\n\nThis action-packed mode offers:\n1. A wide selection of unique spunky characters, as well as a variety of innovative weapons and protective armor.\n2. The freedom to construct and demolish structures, adding another layer of strategy to the gameplay.\n3. Numerous decorative items for you to use and create immersive scenes.",
        "ratingCount": 8834,
        "thumbnailUrl": "https://images.randplays.com/p_405184.png"
    },
    {
        "id": 345,
        "title": "Draw Perfect Circle",
        "layout": "auto",
        "rating": 3.3,
        "urlkey": "Draw-Perfect-Circle",
        "gameUrl": "https://game.randplays.com/iframe.html?id=408892",
        "category_id": 9,
        "description": "Don't hesitate to play if you're busy or have other plans! Once you decide to play, forget about everything and let your creative side take over. Draw the most flawless circle you can imagine. \nCreate a picture-perfect triangle.\nSketch a flawless square. \nEmbrace your artistic abilities and draw a multitude of impeccable shapes! \nKeep on drawing until you achieve the utmost perfection in your art. \nRemember, the only rule is to draw flawlessly.",
        "ratingCount": 1041,
        "thumbnailUrl": "https://images.randplays.com/p_408892.png"
    },
    {
        "id": 350,
        "title": "Sprunki Mahjong",
        "layout": "landscape",
        "rating": 4.1,
        "urlkey": "Sprunki-Mahjong",
        "gameUrl": "https://game.randplays.com/iframe.html?id=437259",
        "category_id": 2,
        "description": "Sprunki Mahjong is an exciting puzzle game where you pair up Sprunki pieces, just like in traditional mahjong. The vibrant visuals and addictive gameplay of this game are sure to keep you entertained. But beware, there's a hidden horror element that adds an extra thrill to the adventure!\n\nSee how you stack up against other players on the leaderboard and get ready for a rollercoaster of emotions.",
        "ratingCount": 26,
        "thumbnailUrl": "https://images.randplays.com/p_437259.png"
    },
    {
        "id": 351,
        "title": "Unblocked",
        "layout": "auto",
        "rating": 3.7,
        "urlkey": "Unblocked",
        "gameUrl": "https://game.randplays.com/iframe.html?id=98355",
        "category_id": 9,
        "description": "We need to clear a path for the red block. How many moves will you need to do this?\\\\r\n\\\\r\nGame Features:\\\\r\n- Fun and positive design\\\\r\n- 24 challenging levels\\\\r\n- Interactive system of hints that will help you solve the puzzle\\\\r\n\\\\r\nUnblocked is a classic block puzzle game. Players must clear a path to the exit for the red block.\\\\r\n\\\\r\nUsing the mouse or touch screen, players drag and drop blocks to clear a path to the exit for the red block. The number of moves matters. The fewer moves you spend to complete a level, the more stars you will get.\\\\r\n\\\\r\nIf the player is stuck, then to complete the level, he can use a hint (light bulb). With each level, the game becomes more difficult.",
        "ratingCount": 26,
        "thumbnailUrl": "https://images.randplays.com/p_98355.png"
    },
    {
        "id": 353,
        "title": "Backpack Battles: Mobile Edition",
        "layout": "auto",
        "rating": 5,
        "urlkey": "Backpack-Battles",
        "gameUrl": "https://pagegame.randplays.com/BackpackBattles/",
        "category_id": 3,
        "description": "Backpack Battles is a unique strategy and inventory-building PvP game where your backpack is your battlefield.\n\nInstead of controlling a hero directly, you’ll carefully organize weapons, potions, and magical items inside a limited grid-based backpack. Victory depends on how well you plan your layout and synergize your gear—every slot, every rotation, every item matters.\n\n⚔️ Turn-based auto-battles based on your inventory setup\n\n🎒 Grid inventory system with deep strategy\n\n🧪 Hundreds of items and combinations\n\n🔁 Every round is different with roguelike replayability\n\nPrepare your build, organize your backpack, and face off against other players. Winning isn’t about speed—it’s about smart packing.",
        "ratingCount": 452201,
        "thumbnailUrl": "https://image.randplays.com/backpackbattles.jpg"
    },
    {
        "id": 354,
        "title": "Liar's Bar",
        "layout": "landscape",
        "rating": 5,
        "urlkey": "Liars-Bar",
        "gameUrl": "https://pagegame.randplays.com/liarsbar/",
        "category_id": 3,
        "description": "Play instantly in your browser. No download.\nFrom the original developers of the smash-hit Liar’s Bar. Now featuring Liar’s Deck – the ultimate game of lies and strategy.\n\nBluff, Betray, Survive — In Your Browser\n\nSet in a shady bar where lies are currency and trust is dead, Liar’s Bar (Web) pits you against 2–4 players in intense, real-time multiplayer. Outplay your opponents in a twisted blend of poker-inspired mechanics, social deduction, and high-stakes showdowns. It’s not about the cards you’re dealt—it’s about the lies you can sell.\n\nWhat is Liar’s Deck?\nLiar’s Deck is a high-stakes card mode where every move is a gamble and only the most cunning survive. Your goal: lie, bluff, and outsmart the table—or face the consequences.\n\nHow to Play\n1. Players take turns placing cards face-down and announcing what they’ve played.\n2. Anyone can call a bluff—triggering tense standoffs.\n3. If a bluff is caught, the liar faces Russian roulette with the gun on the table.\n4. Last player standing wins.\n\nSpecial Rounds & Rules\n1. Each round uses a preset—King’s Table, Queen’s Table, or Ace’s Table—which dictates which cards must be played.\n2. Jokers can substitute any card, opening fresh ways to trick opponents.\n3. Run out of cards? You’re forced into a sudden-death Russian roulette round.",
        "ratingCount": 452201,
        "thumbnailUrl": "https://images.randplays.com/liarsbar.jpg"
    }
]
export const featureids = [109, 101, 225, 265, 271, 77, 294, 304, 320, 321, 43, 118, 67, 62, 25, 72, 54, 29, 23, 18, 37];
const idSet = new Set(featureids);
var fgames = [];
var gmap: any = {};
for (var g of allGames) {
    gmap[g.id || 0] = g;
}

for (var id of featureids) {
    fgames.push(gmap[id]);
}
export const featuredGames = fgames;
export const categories: Category[] = [{ "id": 1, "name": "Action" }, { "id": 2, "name": "Puzzle" }, { "id": 3, "name": "Strategy" }, { "id": 4, "name": "Adventure" }, { "id": 7, "name": "Kids" }, { "id": 8, "name": "Sports" }, { "id": 9, "name": "Casual" }, { "id": 10, "name": "Shooting" }, { "id": 11, "name": "Girls" }, { "id": 12, "name": "Classics" }, { "id": 13, "name": "Arcade" }, { "id": 14, "name": "Boys" }, { "id": 15, "name": "Horror" }, { "id": 16, "name": "Racing" }, { "id": 17, "name": "Simulator" }, { "id": 18, "name": "Board" }];